export default {
    "generalErrorMessage": {
        "fieldIsRequired": "यह क्षेत्र आवश्यक है",
        "field_required": "यह क्षेत्र आवश्यक है",
        "something_went_wrong": "कुछ गलत हो गया"
    },
    "authErrorMessage": {
        "emailError": "ईमेल क्षेत्र में एक वैध ईमेल होना चाहिए",
        "passwordValid": "पासवर्ड क्षेत्र में कम से कम 8 वर्ण होने चाहिए",
        "validPassRegex": "पासवर्ड में कम से कम 8 वर्ण होने चाहिए, और कम से कम 1 वर्णमाला, 1 अपरकेस, 1 अंक, और 1 विशेष वर्ण होना चाहिए",
        "confirmPasswordValid": "कन्फ़र्म पासवर्ड पुष्टि मेल नहीं खाती",
        "validCharactersfirst": "पहले नाम क्षेत्र में केवल वर्णमाला वर्ण और स्पेस हो सकते हैं",
        "validCharacterslast": "आखिरी नाम क्षेत्र में केवल वर्णमाला वर्ण और स्पेस हो सकते हैं",
        "minMust": "कम से कम 3 वर्ण होने चाहिए",
        "must_be_a_valid_email": "यह एक वैध ईमेल होना चाहिए",
        "currentPassword": "वर्तमान पासवर्ड कम से कम 8 अक्षर लंबा होना चाहिए, और इसमें कम से कम 1 अक्षर, 1 अपरकेस, 1 संख्यात्मक और 1 विशेष अक्षर होना चाहिए",
        "newPassword": "नए पासवर्ड कम से कम 8 अक्षर लंबे होने चाहिए और उनमें कम से कम 1 अक्षर, 1 अपरकेस, 1 संख्यात्मक और 1 विशेष अक्षर होना चाहिए।",
        "currentPasswordValid": "वर्तमान पासवर्ड फ़ील्ड कम से कम 8 अक्षर की होनी चाहिए",
        "newPasswordValid": "नया पासवर्ड फ़ील्ड कम से कम 8 अक्षर का होना चाहिए",
        "please_wait_before_resending_email": "कृपया अपना ईमेल जांचें। यदि आपको यह प्राप्त नहीं हुआ है, तो आप 1 मिनट बाद पुनः सत्यापन ईमेल भेज सकते हैं।"
    },
    "companyErrorMessage": {
        "phoneNumberValid": "फोन नंबर क्षेत्र में कम से कम 10 वर्ण होने चाहिए",
        "Something_went_wrong_Please_contact_to_admin": "कुछ गलत हो गया। कृपया प्रशासन से संपर्क करें"
    },
    "errorPage": {
        "project_name": "प्रोजेक्ट नाम",
        "project_key": "प्रोजेक्ट कुंजी",
        "project_category": "प्रोजेक्ट श्रेणी",
        "team_name": "टीम नाम",
        "The": "यह",
        "field_must_be_a_valid": "क्षेत्र एक वैध होना चाहिए",
        "email": "ईमेल",
        "password": "पासवर्ड",
        "first_name": "पहला नाम",
        "last_name": "आखिरी नाम",
        "company_name": "कंपनी नाम",
        "file_extension": "फाइल एक्सटेंशन",
        "milestone_status": "माइलस्टोन स्थिति",
        "name": "नाम",
        "phone_number": "फोन नंबर",
        "field_must_be_at_least": "क्षेत्र में कम से कम होना चाहिए",
        "number": "संख्या",
        "characters": "वर्ण",
        "digits": "अंकों",
        "priority_name": "प्राथमिकता नाम",
        "firstName": "पहला नाम",
        "lastName": "आखिरी नाम",
        "phoneNumber": "फोन नंबर",
        "amount": "राशि",
        "phone": "फोन",
        "country": "देश",
        "state": "राज्य",
        "city": "शहर",
        "templatename": "टेम्पलेट नाम",
        "description": "विवरण",
        "Template_name_is_required": "टेम्पलेट नाम आवश्यक है",
        "This_template_name_is_required.": "यह टेम्पलेट नाम आवश्यक है",
        "status": "स्थिति",
        "zipcode": "ज़िपकोड",
        "address2": "पता 2",
        "address1": "पता 1",
        "The_confirm_password_field_is_required": "कन्फ़र्म पासवर्ड क्षेत्र आवश्यक है",
        "The_confirm_password_confirmation_does_not_match": "कन्फ़र्म पासवर्ड पुष्टि मेल नहीं खाती",
        "terms_and_condition": "नियम और शर्तें",
        "category_name": "श्रेणी नाम",
        "channel_name": "चैनल नाम",
        "amount_per_hours": "प्रति घंटा राशि",
        "refundamount": "रिफंड राशि",
        "please_select_template": "कृपया टेम्पलेट चुनें",
        "template_name_already_exists": "टेम्पलेट नाम पहले से मौजूद है",
        "select_a_date": "एक तिथि चुनें",
        "must_be_less_than": "इससे कम होना चाहिए",
        "project_duedate": "प्रोजेक्ट की अंतिम तिथि",
        "project_lead_assignee": "प्रोजेक्ट लीड असाइन",
        "current_password": "वर्तमान पासवर्ड",
        "new_password": "नया पासवर्ड",
        "confirm_password": "पासवर्ड की पुष्टि कीजिये",
        "This_template_name_is_already_exists": "यह टेम्पलेट नाम पहले से मौजूद है",
        "card_name": "कार्ड का नाम",
        "topic": "विषय",
        "target_audience": "लक्षित दर्शक",
        "keywords": "मुख्य शब्द",
        "content_purpose": "सामग्री का उद्देश्य",
        "product/service": "उत्पाद/सेवा",
        "campaign_goals": "अभियान के लक्ष्य",
        "value_proposition": "मूल्य प्रस्ताव",
        "objectives": "उद्देश्य",
        "key_message": "मुख्य संदेश",
        "problem": "समस्या",
        "context": "संदर्भ",
        "constraints": "बाधाएं",
        "main_keyword": "मुख्य कीवर्ड",
        "secondary_keywords": "द्वितीयक कीवर्ड",
        "content_goal": "सामग्री का लक्ष्य",
        "keyword_list": "कीवर्ड सूची",
        "questions": "प्रश्न",
        "product_description": "उत्पाद विवरण",
        "feedback_data": "फीडबैक डेटा",
        "survey_questions": "सर्वे के प्रश्न",
        "project": "परियोजना",
        "progress_made": "हुई प्रगति",
        "next_steps": "अगले चरण",
        "key_features": "मुख्य विशेषताएं",
        "client_type": "ग्राहक प्रकार",
        "challenges": "चुनौतियां",
        "results": "परिणाम",
        "event_type": "कार्यक्रम प्रकार",
        "cta": "कार्य आह्वान",
        "campaign_objectives": "अभियान उद्देश्य",
        "survey_objectives": "सर्वे उद्देश्य",
        "column_one_name": "पहले कॉलम का नाम",
        "column_two_name": "दूसरे कॉलम का नाम",
        "column_one_data": "पहले कॉलम का डेटा",
        "column_two_data": "दूसरे कॉलम का डेटा",
        "customer_name": "ग्राहक का नाम",
        "email_purpose": "ईमेल का उद्देश्य",
        "talking_points": "चर्चा के मुद्दे",
        "product_name": "उत्पाद का नाम",
        "about_the_product": "उत्पाद के बारे में",
        "core_problem_it_solves": "यह जो मुख्य समस्या हल करता है",
        "what_makes_it_different": "क्या इसे अलग बनाता है",
        "the_product_is": "उत्पाद है",
        "core_differentiators": "मुख्य भेदकर्ता",
        "product/service_benefits": "उत्पाद/सेवा लाभ",
        "call_notes": "कॉल नोट्स",
        "call_transcript": "कॉल प्रतिलेख",
        "target_company": "लक्षित कंपनी",
        "use_case": "उपयोग का मामला",
        "customer_challenges": "ग्राहक की चुनौतियां",
        "territories": "क्षेत्र",
        "target_industries": "लक्षित उद्योग",
        "sales_goals": "बिक्री लक्ष्य",
        "sales_strategies": "बिक्री रणनीति",
        "transcript": "प्रतिलेख",
        "pain_points": "दर्द के बिंदु",
        "company_type": "कंपनी प्रकार",
        "sales_cycle_stages": "बिक्री चक्र चरण",
        "sales_methodologies": "बिक्री पद्धतियां",
        "key_skills": "मुख्य कौशल",
        "training_formats": "प्रशिक्षण प्रारूप",
        "participants": "प्रतिभागी",
        "target_industry": "लक्षित उद्योग",
        "value_statement": "मूल्य कथन",
        "meeting_type": "बैठक प्रकार",
        "your_talking_points": "आपके चर्चा के मुद्दे",
        "goal": "लक्ष्य",
        "reasons_for_canceling": "रद्द करने के कारण",
        "incentive": "प्रोत्साहन",
        "unique_selling_points": "अनोखे बिक्री बिंदु",
        "desired_format": "वांछित प्रारूप",
        "topics": "विषय",
        "content": "सामग्री",
        "stakeholders": "हितधारक",
        "sales_notes": "बिक्री नोट्स",
        "customer_goals": "ग्राहक लक्ष्य",
        "teams_impacted": "प्रभावित टीम",
        "requirements": "आवश्यकताएं",
        "goals_met": "पूरे हुए लक्ष्य",
        "project_stakeholders": "परियोजना हितधारक",
        "opportunities": "अवसर",
        "risks": "जोखिम",
        "customer_message": "ग्राहक संदेश",
        "date_range": "तारीख सीमा",
        "project_notes": "परियोजना नोट्स",
        "project_description": "परियोजना विवरण",
        "name_of_project": "परियोजना का नाम",
        "date_ranges": "तारीख सीमाएं",
        "requestor": "अनुरोधकर्ता",
        "requests": "अनुरोध",
        "reason_for_the_change": "परिवर्तन का कारण",
        "expected_impact_of_the_change": "परिवर्तन का अपेक्षित प्रभाव",
        "project_goals": "परियोजना लक्ष्य",
        "participant_names": "प्रतिभागियों के नाम",
        "meeting_time": "बैठक का समय",
        "timeline": "समयसीमा",
        "deliverables": "डिलिवरेबल्स",
        "project_goal": "परियोजना लक्ष्य",
        "project_scope": "परियोजना का दायरा",
        "main_task": "मुख्य कार्य",
        "new_format": "नया प्रारूप",
        "original_text": "मूल पाठ",
        "stakeholder_titles": "हितधारक पद",
        "article_title": "लेख शीर्षक",
        "focus_keywords": "फोकस कीवर्ड",
        "title_of_the_blog_text": "ब्लॉग टेक्स्ट का शीर्षक",
        "blog_topic": "ब्लॉग विषय",
        "section_title": "अनुभाग शीर्षक",
        "section_content": "अनुभाग सामग्री",
        "section": "अनुभाग",
        "title": "शीर्षक",
        "title(faq_question)": "शीर्षक(FAQ प्रश्न)",
        "issue_description": "मुद्दे का विवरण",
        "code_section": "कोड अनुभाग",
        "concept": "अवधारणा",
        "version": "संस्करण",
        "changes": "परिवर्तन",
        "job_title": "नौकरी का शीर्षक",
        "your_name": "आपका नाम",
        "your_skills": "आपके कौशल",
        "math_question": "गणित का प्रश्न",
        "question": "प्रश्न",
        "thesis_topic": "शोध प्रबंध विषय",
        "text_to_proofread": "जांच के लिए पाठ",
        "text_to_rephrase": "पुनः लिखने के लिए पाठ",
        "text_to_improve": "सुधारने के लिए पाठ",
        "job_description": "नौकरी का विवरण",
        "your_title": "आपका पद",
        "your_summary": "आपका सारांश",
        "pain": "दर्द",
        "agitation": "आंदोलन",
        "solution": "समाधान",
        "post_content": "पोस्ट सामग्री",
        "product_or_service": "उत्पाद या सेवा",
        "unique_selling_proposition": "अनोखा बिक्री प्रस्ताव",
        "audiences_objectives": "दर्शकों के उद्देश्य",
        "email_to_reply_to": "जवाब देने के लिए ईमेल",
        "sales_teams_roles": "बिक्री टीम की भूमिकाएं"
    },
    "Auth": {
        "email": "ईमेल",
        "password": "पासवर्ड",
        "firstName": "पहला नाम",
        "lastName": "आखिरी नाम",
        "phoneNumber": "फोन नंबर",
        "login_descriptioon": "देखें कि आपके व्यवसाय में क्या हो रहा है",
        "login_statement": "अपने खाते में लॉगिन करें",
        "email_id": "ईमेल आईडी",
        "Password": "पासवर्ड",
        "Conform_pass": "कन्फ़र्म पासवर्ड",
        "RememberMeL": "मुझे याद रखें",
        "Remember_password": "पासवर्ड याद रखें",
        "Forgot_Password": "पासवर्ड भूल गए",
        "loading": "लोड हो रहा है",
        "loging": "लॉगिन कर रहे हैं",
        "Register": "रजिस्टर करें",
        "NotR": "अभी तक पंजीकरण नहीं किया है",
        "createAcc": "खाता बनाएं",
        "alredyacc": "क्या आपका पहले से खाता है?",
        "ResendEmail": "ईमेल पुनः भेजें",
        "pleasecheck": "कृपया अपना ईमेल जांचें, यदि आपने इसे प्राप्त नहीं किया है या इसे गलत जगह पर डाल दिया है, तो कृपया नीचे क्लिक करके ईमेल पुनः भेजें।",
        "backlogin": "लॉगिन पर वापस जाएं",
        "Welcome_Msg": "BRAND_NAME में स्वागत है",
        "Welcome_Description": "खाता बनाकर विशेष सुविधाओं का लाभ प्राप्त करें",
        "agree": "मैं सहमत हूं",
        "tearm": "सेवा की शर्तें",
        "and": "और",
        "Privacy_Policy": "गोपनीयता नीति",
        "forgatepasswordmsg": "अपने खाते से संबंधित ईमेल दर्ज करें और हम आपको पासवर्ड रीसेट करने के लिए निर्देशों के साथ एक ईमेल भेजेंगे।",
        "ltitle": "बड़ी विचारों पर काम करें, बिना किसी व्यस्तता के।",
        "time_format": "समय प्रारूप",
        "timezone": "समय क्षेत्र",
        "selectLanguage": "भाषा चयन करें",
        "check_credentials": "कृपया अपनी क्रेडेंशियल्स जांचें।",
        "check_smtp_credentials": "कृपया अपनी SMTP क्रेडेंशियल्स जांचें।",
        "smtp_successfully_verified": "आपका SMTP सफलतापूर्वक सत्यापित हो गया है।",
        "verification_code_invalid": "आपका सत्यापन कोड अमान्य है।",
        "verification_code_invalid_check_code": "आपका सत्यापन कोड अमान्य है। कृपया अपना कोड जांचें।",
        "verification_mail_sent": "सत्यापन मेल सफलतापूर्वक भेज दिया गया है। कृपया अपना इनबॉक्स जांचें।",
        "no_account_found_for_email": "दी गई ईमेल के लिए कोई खाता नहीं मिला।",
        "verify_email_and_try_again": "कृपया अपना ईमेल सत्यापित करें और फिर से प्रयास करें।",
        "confirm_password": "कन्फ़र्म पासवर्ड",
        "enter_new_password": "कृपया अपना नया पासवर्ड दर्ज करें",
        "link_expired_resend_email": "आपका लिंक समाप्त हो गया है।",
        "reset_password": "पासवर्ड रीसेट करें",
        "resend_verification_email": "कृपया सत्यापन ईमेल पुनः भेजने के लिए बटन पर क्लिक करें",
        "link_expired": "यह लिंक समाप्त हो चुका है",
        "too_many_request": "आपने दिए गए समय में बहुत अधिक अनुरोध भेजे हैं। कृपया प्रतीक्षा करें और बाद में पुनः प्रयास करें।",
        "previous_wasnot_valid": "आपका पिछला पासवर्ड मान्य नहीं था। कृपया सत्यापित करें और पुनः प्रयास करें।",
        "password_wasnot_valid": "आपका नया पासवर्ड मान्य नहीं था। कृपया पुनः प्रयास करें।",
        "set_new_password": "नया पासवर्ड सेट करें",
        "oAuthGoogleBtnText": "गूगल के साथ जारी रखें"
    },
    "Home": {
        "unlock": "अनलॉक करें",
        "lock": "लॉक करें",
        "dashboardLockSuccess": "डैशबोर्ड सफलतापूर्वक लॉक किया गया",
        "dashboardUnlockSuccess": "डैशबोर्ड सफलतापूर्वक अनलॉक किया गया",
        "Home": "होम",
        "My_Work": "मेरा काम",
        "Done": "हो गया",
        "To_Do": "करने के लिए",
        "no_task_found": "कोई कार्य नहीं मिला",
        "Confirm": "पुष्टि करें",
        "tourclose": "क्या आप सुनिश्चित हैं कि आप इस टूर को बंद करना चाहते हैं? यदि आप पुष्टि करते हैं, तो आप इस टूर गाइड को फिर से एक्सेस नहीं कर सकेंगे।",
        "Queue_List": "क्यू सूची",
        "AddtoQueue": "क्यू में जोड़ें",
        "noquelist": "कोई क्यू सूची नहीं मिली",
        "Due_Date": "नियत तिथि",
        "createQueueTitle": "क्यू बनाएं",
        "Today": "आज",
        "Calendar": "कैलेंडर",
        "Hide": "छिपाएं",
        "Overdue": "अतिरिक्त समय",
        "Next": "अगला",
        "Unscheduled": "अनुसूचित नहीं",
        "task_assign_to_you": "कार्य आपको सौंपा गया है",
        "Notification_Request": "सूचना अनुरोध",
        "no": "नहीं",
        "yes": "हां",
        "add_task_type": "कार्य प्रकार जोड़ें",
        "are_you_sure": "क्या आप सुनिश्चित हैं कि आप ब्राउज़र सूचनाएं सक्षम करना चाहते हैं?"
    },
    "Header": {
        "Project_Forecasting": "परियोजना पूर्वानुमान (जल्द आ रहा है)",
        "Resource_Planning": "संसाधन योजना (जल्द आ रही है)",
        "Projects": "प्रोजेक्ट्स",
        "Time_Sheet": "टाइम शीट",
        "User_Timesheet": "उपयोगकर्ता टाइमशीट",
        "project_Timesheet": "प्रोजेक्ट टाइमशीट",
        "Workload_Timesheet": "वर्कलोड टाइमशीट",
        "Tracker_Timesheet": "ट्रैकर टाइमशीट",
        "Reports": "रिपोर्ट्स",
        "Milestone_Report": "माइलस्टोन रिपोर्ट",
        "Time_Forcasting": "समय पूर्वानुमान",
        "Chat": "चैट",
        "Notification": "सूचना",
        "mention": "उल्लेख",
        "Tours": "टूर",
        "Logout": "लॉगआउट",
        "Mark_all_as_read": "सभी को पढ़ा हुआ मार्क करें",
        "Mark_all_as_complete": "सभी को पूरा मार्क करें",
        "designation": "पद",
        "upgrade_now": "अब अपग्रेड करें",
        "load_more": "अधिक लोड करें",
        "take_tour": "टूर लें",
        "task_details": "कार्य विवरण",
        "Comments": "टिप्पणियाँ",
        "activity_log": "सक्रियता लॉग",
        "time_log": "समय लॉग",
        "mentions": "उल्लेख",
        "Notifications": "सूचनाएँ",
        "no_data_found": "कोई डेटा नहीं मिला",
        "search_results": "खोज परिणाम",
        "my_profile": "मेरा प्रोफाइल",
        "billing_history": "बिलिंग इतिहास",
        "Assignee": "आसाइन किए गए व्यक्ति",
        "Due Date": "नियत तिथि",
        "Priority": "प्राथमिकता",
        "Key": "कुंजी",
        "Created Date": "निर्माण तिथि",
        "Created By": "निर्माता",
        "advance_search": "उन्नत खोज",
        "for_advance_search": "उन्नत खोज के लिए",
        "get_more": "अधिक प्राप्त करें?",
        "to_unlock_activity_view": "सक्रियता दृश्य अनलॉक करने के लिए",
        "AssigneeUserId": "आसाइन किए गए व्यक्ति",
        "DueDate": "नियत तिथि",
        "TaskKey": "कुंजी",
        "Task_Priority": "कार्य प्राथमिकता",
        "commentCounts": "चैट",
        "created_by": "निर्माता",
        "created_date": "निर्माण तिथि",
        "create_project": "प्रोजेक्ट बनाएं",
        "Company": "कंपनी"
    },
    "ProjectDetails": {
        "select_project_category": "प्रोजेक्ट श्रेणी चुनें",
        "select_currency": "मुद्रा चुनें",
        "description": "विवरण",
        "details": "विवरण",
        "status": "स्थिति",
        "assignee": "आसाइन किए गए व्यक्ति",
        "key": "कुंजी",
        "category": "श्रेणी",
        "source": "स्रोत",
        "type": "प्रकार",
        "billing_period": "बिलिंग अवधि",
        "currency": "मुद्रा",
        "amount": "राशि",
        "start_date": "आरंभ तिथि",
        "end_date": "समाप्ति तिथि",
        "no_start_date": "कोई आरंभ तिथि नहीं",
        "no_end_date": "कोई समाप्ति तिथि नहीं",
        "no_due_date": "कोई नियत तिथि नहीं",
        "msg": "आरंभ तिथि को संशोधित नहीं किया जा सकता क्योंकि यह पहले से ही",
        "msgbr": "माइलस्टोन रेंज के भीतर है।",
        "startdatemsg0": "आरंभ तिथि को संशोधित नहीं किया जा सकता क्योंकि यह पहले से ही",
        "startdatemsg1": "माइलस्टोन रेंज के भीतर है।",
        "ok": "ठीक है",
        "lead": "लीड",
        "browse_by_category": "श्रेणी द्वारा ब्राउज़ करें",
        "subtask": "उपकार्य",
        "details_project_setup": "प्रोजेक्ट सेटअप का विवरण",
        "avatar": "अवतार",
        "shared_with": "साझा किया गया",
        "no_user_selected": "कोई उपयोगकर्ता चयनित नहीं",
        "required_view": "आवश्यक दृश्य",
        "set_the_require": "वह दृश्य सेट करें जो आपको आवश्यक हैं। ये दृश्य स्वचालित रूप से तब सेट हो जाएंगे जब आप BRAND_NAME में प्रोजेक्ट्स, फोल्डर्स, और लिस्ट्स पर नेविगेट करेंगे, बजाय इसके कि आपको उन्हें मैन्युअली बनाना पड़े। एक बार बनाए जाने के बाद, दृश्य को हटाया नहीं जा सकता।",
        "always_required": "हमेशा आवश्यक",
        "make_default": "डिफ़ॉल्ट बनाएं",
        "reporter": "रिपोर्टर",
        "copy_task_link": "कार्य लिंक कॉपी करें",
        "copy_task_key": "कार्य कुंजी कॉपी करें",
        "add_que_list": "क्यू सूची में जोड़ें",
        "remove_que_list": "क्यू सूची से हटाएं",
        "convert_list": "सूची में बदलें",
        "convert_subtask": "उपकार्य में बदलें",
        "merge": "मर्ज करें",
        "move": "मूव करें",
        "convert_task": "कार्य में बदलें",
        "no_currency_found": "कोई मुद्रा नहीं मिली",
        "remove_from_queue_list": "क्यू सूची से हटाएं",
        "convert": "बदलें",
        "DUPLICATE_AND_OPEN": "डुप्लिकेट करें और खोलें",
        "MOVE_AND_OPEN": "मूव करें और खोलें",
        "CONVERT_AND_OPEN": "बदलें और खोलें",
        "MERGE_AND_OPEN": "मर्ज करें और खोलें"
    },
    "ProjectSlider": {
        "new_project": "नया प्रोजेक्ट",
        "no_archived": "कोई संग्रहित डेटा नहीं मिला",
        "you_dont": "आपके पास कोई प्रोजेक्ट नहीं हैं",
        "archived_list": "संग्रहित सूची",
        "projects": "प्रोजेक्ट्स",
        "project_name": "प्रोजेक्ट का नाम",
        "folder_name": "फ़ोल्डर का नाम",
        "sprint_name": "स्प्रिंट का नाम",
        "show_archive": "संग्रहण दिखाएं",
        "hide_archive": "संग्रहण छिपाएं",
        "try_using_diff": "विभिन्न कीवर्ड का उपयोग करने का प्रयास करें",
        "no_project_found": "कोई प्रोजेक्ट नहीं मिला",
        "no_result_found": "कोई परिणाम नहीं मिला",
        "select_project_status": "प्रोजेक्ट की स्थिति चुनें",
        "no_activity_log_found": "कोई गतिविधि लॉग नहीं मिला"
    },
    "Projects": {
        "sprint": "स्प्रिंट",
        "folder": "फ़ोल्डर",
        "task_view": "कार्य दृश्य",
        "default_view": "डिफ़ॉल्ट दृश्य",
        "add_view": "व्यू जोड़ें",
        "rename": "नाम बदलें",
        "pin": "पिन करें",
        "edit_code": "कोड संपादित करें",
        "copy_link": "लिंक कॉपी करें",
        "delete": "हटाएं",
        "view": "दृश्य",
        "watchers": "देखने वाले",
        "files_links": "फ़ाइलें और लिंक",
        "audio_files": "ऑडियो फ़ाइलें",
        "project_permissions": "प्रोजेक्ट अनुमतियां",
        "color_avatar": "रंग और अवतार",
        "duplicate": "डुप्लिकेट करें",
        "close_project": "प्रोजेक्ट बंद करें",
        "archive": "संग्रहित करें",
        "search_in": "में खोजें",
        "expanded": "विस्तारित",
        "collapsed": "संकुचित",
        "me": "मैं",
        "status": "स्थिति",
        "priority": "प्राथमिकता",
        "due_date": "नियत तिथि",
        "group_by": "के अनुसार समूहित करें",
        "subtask": "उपकार्य",
        "task_name": "कार्य का नाम",
        "task_key": "कार्य कुंजी",
        "everyone": "सभी",
        "private": "निजी",
        "share_with": "साझा करें",
        "create_new_list": "नई सूची बनाएं",
        "create_new_folder": "नया फ़ोल्डर बनाएं",
        "restore": "पुनर्स्थापित करें",
        "unpin": "पिन हटाएं",
        "pinview": "व्यू पिन करें",
        "deleteview": "व्यू हटाएं",
        "close": "बंद करें",
        "cancel": "रद्द करें",
        "tasks": "कार्य",
        "save": "सहेजें",
        "create_project": "प्रोजेक्ट बनाएं",
        "use_template": "टेम्पलेट का उपयोग करें",
        "blank_project": "रिक्त प्रोजेक्ट",
        "no_category_found": "कोई श्रेणी नहीं मिली",
        "template": "टेम्पलेट",
        "save_create": "सहेजें और बनाएं",
        "save_tamplete": "टेम्पलेट के रूप में सहेजें",
        "previous": "पिछला",
        "new_task": "नया कार्य",
        "add_subtask": "उपकार्य जोड़ें",
        "list_of_user": "उपयोगकर्ताओं की सूची",
        "list_of_project_status": "प्रोजेक्ट स्थिति की सूची",
        "list_of_task_type": "कार्य प्रकार की सूची",
        "list_of_task_status": "कार्य स्थिति की सूची",
        "list_cc": "सूची सीसी",
        "category_list": "श्रेणी सूची",
        "created_by": "द्वारा निर्मित",
        "tags": "टैग",
        "task_type": "कार्य प्रकार",
        "workspace": "कार्यस्थान",
        "project_color": "प्रोजेक्ट रंग",
        "search": "खोजें",
        "add_task_need": "जो प्रकार के कार्य आपको चाहिए उन्हें जोड़ें",
        "what_task_want": "आपको कौन सा कार्य प्रकार चाहिए",
        "no_sub_tasks_found": "कोई उपकार्य नहीं मिला",
        "all_project": "सभी प्रोजेक्ट",
        "closed_project": "बंद प्रोजेक्ट",
        "go_to_project": "प्रोजेक्ट्स पर जाएं",
        "reopen_project": "प्रोजेक्ट फिर से खोलें",
        "required_view": "आवश्यक दृश्य",
        "project_status": "प्रोजेक्ट के लिए स्थिति जोड़ें",
        "what_project": "आपको कौन सी प्रोजेक्ट स्थिति चाहिए",
        "active_status": "सक्रिय स्थिति",
        "done_status": "पूर्ण स्थिति",
        "add_status": "स्थिति जोड़ें",
        "close_status": "बंद स्थिति",
        "submit": "सबमिट करें",
        "Audio_Files": "ऑडियो फ़ाइलें",
        "Files_&_Links": "फ़ाइलें और लिंक",
        "no_audio_file": "कोई ऑडियो फ़ाइल नहीं मिली",
        "change_color": "रंग और अवतार बदलें",
        "files": "फ़ाइलें",
        "links": "लिंक",
        "about": "के बारे में",
        "result": "परिणाम",
        "seconds": "सेकंड",
        "sort_by": "के अनुसार क्रमबद्ध करें",
        "relevance": "संबंधिता",
        "last_update": "अंतिम अपडेट",
        "last_created": "अंतिम बनाए गए",
        "issue": "मुद्दा",
        "update": "अपडेट करें",
        "date": "तिथि",
        "time": "समय",
        "duration": "अवधि",
        "duplicate_task": "डुप्लिकेट कार्य",
        "projects": "प्रोजेक्ट",
        "browse_projects": "प्रोजेक्ट्स ब्राउज़ करें",
        "location": "स्थान",
        "add_new": "नया जोड़ें",
        "create_compnay": "कंपनी बनाएं",
        "company_name": "कंपनी का नाम",
        "archived_project": "संग्रहित प्रोजेक्ट",
        "assignee_teams": "टीमें",
        "assignee_user": "उपयोगकर्ता",
        "all": "सभी",
        "restore_project": "प्रोजेक्ट पुनर्स्थापित करें",
        "delete_project": "प्रोजेक्ट हटाएं",
        "items_per_page": "प्रति पृष्ठ आइटम",
        "Assignee": "आसाइन किया गया व्यक्ति",
        "Project_Created_Date": "प्रोजेक्ट निर्माण तिथि",
        "Project_Status": "प्रोजेक्ट स्थिति",
        "Project_Type": "प्रोजेक्ट प्रकार",
        "Comments_Counts": "टिप्पणियों की गिनती",
        "Created_Date": "निर्माण तिथि",
        "Name": "नाम",
        "Running_Time_Tracker": "चल रहा समय ट्रैकर",
        "Assigned_to": "आसाइन किया गया",
        "Project": "प्रोजेक्ट",
        "Currency": "मुद्रा",
        "Milestone_Type": "माइलस्टोन प्रकार",
        "Project_Category": "प्रोजेक्ट श्रेणी",
        "Comment_Type": "टिप्पणी प्रकार",
        "results_in_time": "समय में परिणाम",
        "create_blank_project": "रिक्त प्रोजेक्ट बनाएं",
        "create_project_using_template": "टेम्पलेट का उपयोग करके प्रोजेक्ट बनाएं",
        "choose_apps": "ऐप्स चुनें"
    },
    "Watcher": {
        "ignore": "नज़रअंदाज करें",
        "participating_mentions": "भाग लेने वाली और {'@'}मेंशन",
        "list_of_watcher": "वॉचर की सूची",
        "all_activity": "सभी गतिविधियाँ",
        "watchers_list": "वॉचर्स सूची",
        "owner": "स्वामी"
    },
    "ViewList": {
        "List": "सूची",
        "Board": "बोर्ड",
        "Project Details": "प्रोजेक्ट विवरण",
        "Comments": "टिप्पणियाँ",
        "Calendar": "कैलेंडर",
        "Activity": "गतिविधि",
        "Workload": "कार्यभार",
        "Gantt": "गांट",
        "Table": "तालिका",
        "Timeline": "टाइमलाइन",
        "Embed": "एंबेड",
        "Comment": "टिप्पणी",
        "to_unlock_list_view": "सूची दृश्य को अनलॉक करने के लिए",
        "error_message_for_empty": "कृपया कम से कम एक दृश्य चुनें।",
        "set_as_default": "डिफ़ॉल्ट के रूप में सेट करें",
        "remove_as_default": "डिफ़ॉल्ट के रूप में हटाएं"
    },
    "Apps": {
        "tags": "टैग",
        "Priority": "प्राथमिकता",
        "TimeEstimates": "समय अनुमान",
        "Milestones": "मील का पत्थर",
        "MultipleAssignees": "कई असाइन किए गए",
        "CustomFields": "कस्टम फ़ील्ड्स",
        "TimeTracking": "समय ट्रैकिंग",
        "AI": "ए.आई."
    },
    "Tags": {
        "no_tags_found": "कोई टैग नहीं मिला",
        "search_or_create_new": "खोजें या नया टैग बनाएं",
        "change_color": "रंग बदलें",
        "delete_tag": "टैग हटाएं",
        "delete_tag_desc": "क्या आप सुनिश्चित हैं कि आप इस स्पेस में हर जगह से टैग हटाना चाहते हैं?",
        "note_msg": "नया टैग बनाने के लिए एंटर दबाएं",
        "This_tag_has_already_been_added": "यह टैग पहले ही जोड़ा जा चुका है",
        "Tag_name_required": "टैग का नाम आवश्यक है"
    },
    "Embeded": {
        "Anything": "कुछ भी",
        "Sheets": "गूगल शीट्स",
        "Docs": "गूगल डॉक्स",
        "Youtube": "यूट्यूब",
        "Figma": "फिगमा",
        "The_name_is_required": "नाम आवश्यक है",
        "The_name_should_be_at_least_3_characters_long": "नाम कम से कम 3 वर्णों का होना चाहिए",
        "The_url_is_required": "URL आवश्यक है",
        "Please_enter_valid_url": "कृपया वैध URL दर्ज करें",
        "URL_already_exists": "URL पहले से मौजूद है",
        "The_Html_code_is_required": "HTML कोड आवश्यक है",
        "name_already_exists": "यह नाम पहले से मौजूद है",
        "to_unlock_embed_view": "एंबेड दृश्य को अनलॉक करने के लिए"
    },
    "ViewListdescription": {
        "list_view": "सूची दृश्य का उपयोग करके अपने कार्यों को किसी भी तरह से व्यवस्थित करें - छानें, फ़िल्टर करें, समूहित करें, और कॉलम कस्टमाइज़ करें।",
        "kanban_view": "अपना परफेक्ट बोर्ड बनाएं और आसानी से कॉलमों के बीच कार्यों को खींचें और छोड़ें।",
        "projectdetail_view": "अपनी टीम को विवरण में समझने के लिए प्रारंभिक आवश्यकताएँ, चेकलिस्ट और अटैचमेंट जोड़ें।",
        "Comments_view": "कुछ भी लेकर वास्तविक समय में टिप्पणियाँ जोड़ें ताकि आपकी टीम को सूचित किया जा सके और वे उत्तर दे सकें।",
        "calender_view": "कैलेंडर दृश्य आपकी योजना बनाने, समय-सारणी बनाने और संसाधन प्रबंधन का स्थान है।",
        "table_view": "तालिका दृश्य के साथ अपने कार्यों का आसानी से प्रबंधन, अपडेट और आयोजन करें।",
        "workload_view": "अपनी टीम की क्षमता देखें, कौन अधिक या कम है और तदनुसार कार्य पुनः असाइन करें।",
        "activitylog_view": "किसी स्थान में सभी गतिविधियों का एक संकलित दृश्य प्राप्त करें। लोगों और प्रकार के लिए फ़िल्टर करें ताकि आप जो गतिविधि देख रहे हैं, वह अधिक विशिष्ट हो सके।",
        "add_msg1": "अपने कार्यों के साथ ऐप्स और वेबसाइट्स जोड़ें एंबेड दृश्य के साथ",
        "add_msg2": "समय बचाने और संदर्भ स्विचिंग को कम करने के लिए।",
        "view_name": "दृश्य नाम",
        "embed_URL": "एंबेड URL",
        "embed_HTML": "एंबेड HTML",
        "private_view": "निजी दृश्य"
    },
    "Filters": {
        "filter": "फ़िल्टर",
        "learnmorefilter": "फ़िल्टर के बारे में अधिक जानें",
        "pleaseselectvalid": "कृपया सभी वैध विकल्प चुनें",
        "confirm": "पुष्टि करें",
        "are_you_sure": "क्या आप निश्चित हैं कि आप इसे हटाना चाहते हैं?",
        "clearall": "सभी साफ़ करें",
        "addfilter": "फ़िल्टर जोड़ें",
        "where": "कहाँ",
        "filtering_field": "फ़िल्टरिंग फ़ील्ड",
        "no_date_found": "कोई तिथि नहीं मिली",
        "save_this_filters": "इन फ़िल्टरों को सहेजें",
        "save_filter": "फ़िल्टर सहेजें",
        "save": "सहेजें",
        "update_filter": "फ़िल्टर अपडेट करें",
        "my_filter": "मेरा फ़िल्टर",
        "no_data_found": "कोई डेटा नहीं मिला",
        "show_result": "परिणाम दिखाएं",
        "save_filters": "फ़िल्टर सहेजें",
        "filter_by": "द्वारा फ़िल्टर करें",
        "projects": "प्रोजेक्ट्स",
        "teams": "टीम्स",
        "user": "उपयोगकर्ता",
        "no_comment_found": "कोई टिप्पणी नहीं मिली",
        "no_project_found": "कोई प्रोजेक्ट नहीं मिला",
        "no_file_found": "कोई फ़ाइल नहीं मिली",
        "no_link_found": "कोई लिंक नहीं मिला",
        "filter_operator": "फ़िल्टर ऑपरेटर",
        "options": "विकल्प",
        "priorities": "प्राथमिकताएँ",
        "select_all": "सभी चुनें",
        "milestone_type": "मील का पत्थर प्रकार",
        "comment_type": "टिप्पणी प्रकार",
        "a_to_z": "A से Z",
        "no_files_found": "कोई फ़ाइल नहीं मिली",
        "no_links_found": "कोई लिंक नहीं मिला",
        "no_links_or_files_found": "कोई लिंक या फ़ाइल नहीं मिली",
        "z_to_a": "Z से A",
        "sort_by": "क्रमबद्ध करें",
        "A-Z": "A-Z",
        "Ascending": "आरोही",
        "Descending": "अवरोही",
        "No": "नहीं",
        "Yes": "हाँ",
        "Z-A": "Z-A",
        "Save_this_Filter": "इस फ़िल्टर को सहेजें",
        "Enter_Filter_Name": "फ़िल्टर का नाम दर्ज करें",
        "Select_Options": "विकल्प चुनें",
        "Equal_To": "बराबर",
        "Greater_Than": "से अधिक",
        "Is": "है",
        "Less_Than": "से कम",
        "Clear_All": "सभी साफ़ करें",
        "select_assignee": "असाइन करने वाला चुनें",
        "select_project_types": "प्रोजेक्ट प्रकार चुनें",
        "unselect_all": "सभी चयन हटाएं",
        "are_you_suredelete": "क्या आप सुनिश्चित हैं कि आप इसे हटाना चाहते हैं?",
        "Not_Equals_To": "नहीं है"
    },
    "conformationmsg": {
        "archive": "एक सूची को संग्रहित किया जा सकता है ताकि इसे दृश्य से छुपाया जा सके, लेकिन इसे किसी भी समय पुनर्स्थापित किया जा सकता है। जब आप एक सूची को संग्रहित करते हैं, तो सभी कार्यों को रखा जाता है और खोज योग्य रहते हैं।",
        "delete": "इस प्रोजेक्ट के कार्य और टेम्पलेट्स सभी मिटा दिए जाएंगे। यह पुष्टि करने के लिए प्रोजेक्ट का नाम टाइप करें कि आप वास्तव में सभी कार्यों, टेम्पलेट्स और इस प्रोजेक्ट को हटाना चाहते हैं।",
        "archive0mesg": "यह पुष्टि करने के लिए प्रोजेक्ट का नाम टाइप करें कि आप वास्तव में इस प्रोजेक्ट को बंद करना चाहते हैं",
        "sprintclosemsg": "यह पुष्टि करने के लिए स्प्रिंट का नाम टाइप करें कि आप वास्तव में इस स्प्रिंट को बंद करना चाहते हैं",
        "type": "प्रकार",
        "are_you_sure": "क्या आप निश्चित हैं?",
        "no_revert_msg": "आप इसे पलट नहीं पाएंगे!",
        "yes_delete": "हाँ, इसे हटा दें!",
        "task_will_become_subtasks_of": "कार्य के उप-कार्य बन जाएंगे",
        "Are_you_sure_you_want_to_delete": "क्या आप निश्चित हैं कि आप इसे हटाना चाहते हैं?",
        "subtasks_will_become_subtasks_of": "उप-कार्य के उप-कार्य बन जाएंगे",
        "unlock_board_view": "बोर्ड दृश्य को अनलॉक करने के लिए",
        "unlock_project_detail_view": "प्रोजेक्ट विवरण दृश्य को अनलॉक करने के लिए",
        "unlock_table_view": "तालिका दृश्य को अनलॉक करने के लिए",
        "unlock_workload_view": "कार्यभार दृश्य को अनलॉक करने के लिए",
        "to_unlock_tracker_timesheet": "ट्रैकर टाइमशीट को अनलॉक करने के लिए",
        "to_unlock_user_timesheet": "उपयोगकर्ता टाइमशीट को अनलॉक करने के लिए",
        "unlock_calendar_view": "कैलेंडर दृश्य को अनलॉक करने के लिए"
    },
    "Description": {
        "description": "विवरण",
        "edit": "संपादित करें",
        "add_description": "एक विवरण जोड़ें",
        "show_more": "और दिखाएं",
        "show_less": "कम दिखाएं",
        "description_placeholder": "कुछ लिखें या कमांड और एआई क्रियाओं के लिए '/' टाइप करें",
        "saved": "सहेजा गया"
    },
    "Checklist": {
        "checklist": "चेकलिस्ट",
        "add_checklist": "चेकलिस्ट जोड़ें",
        "suggest_checklists": "चेकलिस्ट सुझाएं",
        "Checklists": "चेकलिस्ट",
        "to_unlock_checklist": "चेकलिस्ट को अनलॉक करने के लिए"
    },
    "Attachments": {
        "attachments": "अटैचमेंट्स",
        "drag_file": "यहाँ आप फाइलों को खींचकर छोड़ सकते हैं।",
        "see_all": "सभी देखें",
        "drop_file": "यहाँ फाइलें छोड़ें या",
        "browse": "ब्राउज़ करें",
        "no_preview_found": "कोई पूर्वावलोकन नहीं मिला",
        "show_all_pages": "सभी पृष्ठ दिखाएं",
        "drop_here": "यहाँ छोड़ें"
    },
    "Milestone": {
        "milestone": "मील का पत्थर",
        "milestone_name": "मील का पत्थर नाम",
        "status_date": "स्थिति तिथि",
        "total_amount": "कुल राशि",
        "are_you_sure": "क्या आप सुनिश्चित हैं कि आप मील का पत्थर हटाना चाहते हैं?",
        "add_new": "एक नया जोड़ें",
        "mileston_status": "मील का पत्थर स्थिति",
        "project_name": "प्रोजेक्ट का नाम",
        "end_date": "समाप्ति तिथि",
        "start_date": "प्रारंभ तिथि",
        "estimated_release": "अनुमानित रिलीज़",
        "release_request_sent": "रिलीज़ अनुरोध भेजा गया",
        "released": "रिलीज़ किया गया",
        "not_funded": "नहीं वित्तपोषित",
        "funded": "वित्तपोषित",
        "project_milestone_Status": "प्रोजेक्ट मील का पत्थर स्थिति",
        "milestone_status_name": "मील का पत्थर स्थिति नाम",
        "date_displaye": "कैलेंडर में दिखायी गई तिथि",
        "past": "भूतकाल",
        "feature": "भविष्य",
        "milestone_weekly_range": "मील का पत्थर साप्ताहिक सीमा",
        "file_extensions": "फाइल एक्सटेंशन",
        "avatar": "अवतार",
        "adding_estimated": "अनुमानित घंटे जोड़ें",
        "range": "सीमा",
        "user": "उपयोगकर्ता",
        "refunded_amount": "वापसी राशि",
        "Max_2_decimal_places_allowed": "अधिकतम 2 दशमलव स्थान अनुमति है",
        "The_refunded_amount_field_should_not_be_more_then_amount": "वापसी राशि फ़ील्ड राशि से अधिक नहीं होनी चाहिए",
        "Amount_field_should_not_be_smaller_than_the_refunded_amount": "राशि फ़ील्ड वापसी राशि से छोटी नहीं होनी चाहिए",
        "The_minute_field_must_be_59_or_less": "मिनट फ़ील्ड 59 या कम होना चाहिए",
        "The_hours_field_is_required": "घंटे फ़ील्ड आवश्यक है",
        "Name_already_exists": "नाम पहले से मौजूद है",
        "The_milestone_status_field_is_required": "मील का पत्थर स्थिति फ़ील्ड आवश्यक है",
        "The_milestone_status_field_must_be_at_leat_characters": "मील का पत्थर स्थिति फ़ील्ड में कम से कम 3 वर्ण होने चाहिए",
        "actual_amount": "वास्तविक राशि",
        "partially_refunded": "आंशिक रूप से वापसी की गई",
        "refunded_amount_should_not_exceed_amount": "वापसी राशि फ़ील्ड राशि से अधिक नहीं होनी चाहिए",
        "total_partially_refunded": "कुल आंशिक रूप से वापसी की गई",
        "field_should_not_be_smaller_than_refund_amount": "फ़ील्ड वापसी राशि से छोटी नहीं होनी चाहिए",
        "white_color_not_allowed": "सफेद रंग अनुमति नहीं है। कृपया एक वैध रंग चुनें",
        "billing": "बिलिंग",
        "per_hour": "प्रति घंटा",
        "adding_taskPlanning": "कार्य योजना जोड़ें"
    },
    "Comment": {
        "created_by": "द्वारा बनाया गया",
        "created_on": "पर बनाया गया",
        "task_name": "कार्य का नाम"
    },
    "UserTimesheet": {
        "back_projects": "प्रोजेक्ट्स पर वापस जाएं",
        "user_timesheet": "उपयोगकर्ता टाइमशीट",
        "back": "वापस",
        "tracked_time": "ट्रैक किया गया समय",
        "manual_time": "मैन्युअल समय",
        "users": "उपयोगकर्ता",
        "logged": "लॉग इन किया गया",
        "hours": "घंटे",
        "estimated": "अनुमानित",
        "no_records_found": "कोई रिकॉर्ड नहीं मिला",
        "project_timesheet": "प्रोजेक्ट टाइमशीट",
        "tracker_timesheet": "ट्रैकर टाइमशीट",
        "workload_timesheet": "वर्कलोड टाइमशीट",
        "milestone_reports": "मील का पत्थर रिपोर्ट्स",
        "add_time": "समय जोड़ें",
        "add_time_log": "समय लॉग जोड़ें",
        "edit_time_log": "समय लॉग संपादित करें",
        "Teams": "टीमें",
        "Users": "उपयोगकर्ता",
        "Projects": "प्रोजेक्ट्स",
        "task_planning": "कार्य योजना",
        "task_remaining_planning": "शेष घंटे",
        "planned": "योजना बनाई गई"
    },
    "ProjectWorkplace": {
        "msg1": "प्रोजेक्ट को सदस्यों के साथ साझा किया जा सकता है। आप प्रोजेक्ट बनाने के बाद फ़ोल्डरों, सूचियों और कार्यों में अतिथि जोड़ सकते हैं।",
        "msg2": "वर्तमान में निजी या सार्वजनिक प्रोजेक्ट बनाने की कोई योजना नहीं है। यदि आप एक प्रोजेक्ट शुरू करना चाहते हैं, तो आपकी योजना को अपग्रेड करना आवश्यक होगा।"
    },
    "CustomField": {
        "custom_field": "कस्टम फ़ील्ड",
        "create_custom_field": "कस्टम फ़ील्ड बनाएं",
        "lable": "लेबल",
        "action": "क्रिया",
        "add_custom_field": "कस्टम फ़ील्ड जोड़ें",
        "add_new_custom_field": "नया कस्टम फ़ील्ड जोड़ें",
        "field_name": "फ़ील्ड नाम",
        "date_created": "तारीख बनाई गई",
        "add_another_item": "एक और आइटम जोड़ें",
        "choose_ready_made_list": "एक तैयार सूची विकल्प चुनें (जैसे, दिन, महीने, आदि)",
        "predefined_options": "पूर्व-निर्धारित विकल्प",
        "selected_by_default": "डिफ़ॉल्ट रूप से चयनित",
        "allow_time_with_date": "उपयोगकर्ताओं को तिथि के साथ समय निर्दिष्ट करने की अनुमति दें।",
        "date_format": "तारीख प्रारूप",
        "days_of_week": "सप्ताह के दिन",
        "past_and_future": "भूतकाल और भविष्य",
        "select_date_format": "एक तारीख प्रारूप चुनें। D दिन, M महीने और Y वर्ष के लिए है।",
        "select_dates_past_future": "उपयोगकर्ताओं को अतीत या भविष्य में तारीखें चुनने दें",
        "select_time_format": "समय प्रारूप चुनें",
        "time_format": "समय प्रारूप",
        "unchecking_day_calendar": "एक दिन को अनचेक करने से वह कैलेंडर में उपलब्ध नहीं होगा",
        "future": "भविष्य",
        "past": "भूतकाल",
        "enter_maximum_limit": "अधिकतम सीमा दर्ज करें",
        "enter_minimum_limit": "न्यूनतम सीमा दर्ज करें",
        "limit_minimum_or_maximum_value": "इस फ़ील्ड के लिए अनुमत न्यूनतम या अधिकतम मान को सीमित करें",
        "maximum_limit_type_not_allowed_value": "अधिकतम सीमा प्रकार के लिए दर्ज किया गया मान अनुमत नहीं है।",
        "maximum_value_should_be_greater_than_minimum_value": "अधिकतम मान न्यूनतम मान से अधिक होना चाहिए",
        "minimum_limit_type_not_allowed_value": "न्यूनतम सीमा प्रकार के लिए दर्ज किया गया मान अनुमत नहीं है।",
        "minimum_value_should_not_be_greater_than_maximum_value": "न्यूनतम मान अधिकतम मान से अधिक नहीं होना चाहिए",
        "no_country_found": "कोई देश नहीं मिला",
        "enter_maximum_limit_type": "अधिकतम सीमा प्रकार दर्ज करें",
        "enter_minimum_limit_type": "न्यूनतम सीमा प्रकार दर्ज करें",
        "limit_minimum_or_maximum_text_allowed": "इस फ़ील्ड में अनुमत न्यूनतम या अधिकतम टेक्स्ट की मात्रा को सीमित करें",
        "max_should_be_greater_than_min": "अधिकतम मान न्यूनतम से अधिक होना चाहिए",
        "min_should_be_less_than_max": "न्यूनतम मान अधिकतम से कम होना चाहिए",
        "separator": "विभाजक",
        "countryCode": "देश कोड बदलने के लिए इसे चालू करें।"
    },
    "Category": {
        "cateory_name": "श्रेणी नाम",
        "create_category": "श्रेणी बनाएँ",
        "create_channel": "चैनल बनाएं",
        "no_chat_found": "कोई चैट नहीं मिली",
        "upgradeplanemsg": "इस सुविधा का उपयोग करने के लिए कृपया अपनी योजना को अपग्रेड करें।"
    },
    "Channel": {
        "create_channel": "चैनल बनाएं",
        "msg1": "आपने सार्वजनिक और निजी चैनल बनाने की अधिकतम सीमा तक पहुँच लिया है। इस सुविधा का उपयोग करने के लिए कृपया अपनी योजना को अपग्रेड करें",
        "channel_name": "चैनल का नाम",
        "icons": "आइकन",
        "or": "या",
        "only_share_with": "केवल इसके साथ साझा करें",
        "private_channel": "निजी चैनल",
        "msg2": "केवल चयनित सदस्य और भूमिकाएँ इस चैनल को देख पाएंगे",
        "allowmsg2": "सदस्यों को इस चैनल में संदेश भेजने की अनुमति देता है",
        "send_messages": "संदेश भेजें",
        "choose_to_upload": "अपलोड करने के लिए एक छवि चुनें",
        "private_channel_limit_reached": "आपने निजी चैनल बनाने की सीमा तक पहुँच लिया है। आप केवल सार्वजनिक चैनल बना सकते हैं। यदि आप एक निजी चैनल बनाना चाहते हैं, तो कृपया अपनी योजना को अपग्रेड करें।",
        "public_channel_limit_reached": "आपने सार्वजनिक चैनल बनाने की सीमा तक पहुँच लिया है। आप केवल निजी चैनल बना सकते हैं। यदि आप एक सार्वजनिक चैनल बनाना चाहते हैं, तो कृपया अपनी योजना को अपग्रेड करें।"
    },
    "Templates": {
        "delete_template": "टेम्पलेट हटाएं",
        "project_status": "प्रोजेक्ट स्थिति",
        "task_status": "कार्य स्थिति",
        "no_app_selected": "कोई ऐप चयनित नहीं है",
        "default_views": "दृश्यों के लिए डिफ़ॉल्ट सेटिंग",
        "apps": "ऐप्स",
        "add_new_templete": "नया टेम्पलेट जोड़ें",
        "templates": "टेम्पलेट्स",
        "s": "s",
        "template_name": "टेम्पलेट नाम",
        "upload_image": "चित्र अपलोड करें",
        "all_good": "सब कुछ ठीक है",
        "create_template": "टेम्पलेट बनाएं",
        "new_template": "नया टेम्पलेट",
        "remove": "हटाएं",
        "enable_apps": "ऐप्स सक्षम करें",
        "Turn": "चालू करें",
        "all_apps": "सभी ऐप्स",
        "off": "बंद",
        "on": "चालू",
        "upload": "अपलोड करें",
        "save_template": "टेम्पलेट सेव करें",
        "setup_status": "कार्य के लिए स्थिति सेट करें",
        "what_task": "आप किस कार्य की स्थिति चाहते हैं",
        "select_task_status": "कार्य स्थिति चयनित करें",
        "delete_template_confirmation": "क्या आप वाकई इस टेम्पलेट को हटाना चाहते हैं?",
        "ai_sidebar_title": "AI के साथ टेम्पलेट बनाएं",
        "ai_label_category": "श्रेणी",
        "ai_label_description": "विवरण",
        "ai_button_text_requested_changes": "परिवर्तन का अनुरोध करें",
        "ai_min_view_msg_text": "कम से कम एक दृश्य आवश्यक है",
        "ai_min_msg_text": "कम से कम 10 अक्षर आवश्यक हैं",
        "ai_before_desc_placeholder": "टेम्पलेट जनरेट करने के लिए उपयोग केस विवरण दर्ज करें",
        "ai_after_desc_placeholder": "यहाँ आप संबंधित बदलावों के लिए कुछ भी पूछ सकते हैं",
        "try_with_ai": "एआई के साथ प्रयास करें",
        "msg_search_result_found": "यहाँ कुछ सुझाए गए टेम्पलेट्स हैं जो आपकी आवश्यकताओं के अनुरूप हैं। आप किसी एक को चुन सकते हैं या AI की मदद से नया बनाने के लिए बस क्लिक करें",
        "msg_search_result_not_found": "कोई प्रासंगिक टेम्पलेट्स नहीं मिले। AI का उपयोग करके एक बनाने के लिए, बस क्लिक करें"
    },
    "Settings": {
        "add_new_projects": "नया प्रोजेक्ट जोड़ें",
        "task_priority": "कार्य प्राथमिकता",
        "maximum_image_size": "अधिकतम छवि आकार",
        "warning": "चेतावनी",
        "cant_delete": "हटाया नहीं जा सकता",
        "priority_in_use": "उपयोगकर्ता PRIORITY_NAME प्राथमिकता को नहीं हटा सकता क्योंकि यह पहले से उपयोग में है।",
        "company_name": "कंपनी का नाम",
        "phone": "फोन",
        "country": "देश",
        "state": "राज्य",
        "city": "शहर",
        "select_date_format": "तारीख का प्रारूप चुनें",
        "save_changes": "परिवर्तन सहेजें",
        "currencies": "मुद्राएँ",
        "add_remove_cur": "मुद्राएँ जोड़ें/हटाएं",
        "change_image": "चित्र बदलें",
        "Priorities_already_Exists": "प्राथमिकताएँ पहले से मौजूद हैं",
        "The_priority_image_field_is_required": "प्राथमिकता छवि फ़ील्ड आवश्यक है",
        "The_priority_name_field_is_required": "प्राथमिकता नाम फ़ील्ड आवश्यक है",
        "The_priority_name_field_must_be_at_least": "प्राथमिकता नाम फ़ील्ड कम से कम 3 वर्णों का होना चाहिए",
        "The file extension field is required": "फ़ाइल एक्सटेंशन फ़ील्ड आवश्यक है",
        "The_file_extension_field_must_be_at_least": "फ़ाइल एक्सटेंशन फ़ील्ड कम से कम 3 वर्णों का होना चाहिए",
        "file_extension_is_not_supported": "फ़ाइल एक्सटेंशन समर्थित नहीं है",
        "file_extension_already_Exists": "फ़ाइल एक्सटेंशन पहले से मौजूद है",
        "The_file_extension_field_is_required": "फ़ाइल एक्सटेंशन फ़ील्ड आवश्यक है"
    },
    "Members": {
        "invite": "आमंत्रित करें",
        "all_members": "सभी सदस्य",
        "removed_members": "हटाए गए सदस्य",
        "name": "नाम",
        "role": "भूमिका",
        "last_active": "अंतिम सक्रिय",
        "time_tracker": "समय ट्रैकर",
        "settings": "सेटिंग्स",
        "removeuser": "उपयोगकर्ता हटाएं",
        "adduser": "उपयोगकर्ता जोड़ें",
        "invite_user": "उपयोगकर्ता को आमंत्रित करें",
        "remove_request": "हटाने का अनुरोध",
        "resend_invitation": "आमंत्रण फिर से भेजें",
        "cancel_invitation": "आमंत्रण रद्द करें",
        "Invitation_mail_sent_sucessfully": "आमंत्रण मेल सफलतापूर्वक भेजा गया",
        "confirm_change_user_designation": "क्या आप वाकई इस उपयोगकर्ता की पदनाम को बदलकर करना चाहते हैं",
        "confirm_change_user_role": "क्या आप वाकई इस उपयोगकर्ता की भूमिका बदलकर करना चाहते हैं",
        "Import_users_from_csv": "CSV से उपयोगकर्ता आयात करें"
    },
    "Upgrades": {
        "take_next_step": "अपने काम के साथ अगला कदम उठाएं",
        "you_are_on": "आप वर्तमान में",
        "per_year": "प्रति वर्ष",
        "per_month": "प्रति माह",
        "current_plane": "वर्तमान योजना",
        "per_member": "प्रति सदस्य",
        "and_much_more": "और भी बहुत कुछ",
        "upgrade_to": "अपग्रेड करें",
        "select_payment_method": "भुगतान विधि चयनित करें",
        "plan": "योजना",
        "plane_upgrade": "योजना का उन्नयन सफलतापूर्वक हुआ",
        "plane_upgrade_msg": "योजना उन्नयन सफल! आपकी सदस्यता उन्नत हो गई है। कृपया परिवर्तन प्रभावी होने में 2 से 3 मिनट का समय दें, जिससे आप विस्तारित सुविधाओं और सुधारों का पूरा आनंद ले सकें!",
        "something_wrong": "कुछ गलत हो गया। कृपया पुनः प्रयास करें",
        "unsucessfull_msg": "योजना उन्नयन असफल। हमें आपकी योजना उन्नयन में समस्या का सामना करना पड़ा। कृपया फिर से प्रयास करें या सहायता के लिए संपर्क करें",
        "upgrade_your_plan": "अपनी योजना को उन्नत करें",
        "to_unlock_custom_field": "कस्टम फ़ील्ड अनलॉक करने के लिए",
        "unlimited": "असीमित",
        "the_feature_not_available": "यह सुविधा आपकी वर्तमान योजना पर उपलब्ध नहीं है",
        "unlock_project_permission": "प्रोजेक्ट अनुमति को अनलॉक करने के लिए",
        "unlock_custom_field": "कस्टम फ़ील्ड अनलॉक करने के लिए",
        "to_unlock_milestone": "माइलस्टोन अनलॉक करने के लिए",
        "to_unlock_milestone_report": "माइलस्टोन रिपोर्ट अनलॉक करने के लिए",
        "to_unlock_security": "सुरक्षा और अनुमतियाँ अनलॉक करने के लिए",
        "to_unlock_team": "टीम को अनलॉक करें",
        "to_unlcok_project": "प्रोजेक्ट अनलॉक करने के लिए",
        "You_have_reached_the_free_plan_limit": "आप PLAN_NAME सीमा तक पहुँच गए हैं",
        "require_upgrade_message": "आप PROJECT_NAME योजना पर PROJECT_COUNT परियोजनाएँ बना सकते हैं। अधिक बोर्ड बनाने के लिए अपनी योजना अपग्रेड करें।",
        "are_you_sure_you_want_to_update": "क्या आप वाकई इसे अपडेट करना चाहते हैं?",
        "find_out_whats_included_in_this_update": "इस अपडेट में क्या शामिल है, जानें",
        "improved_performance": "सुधार प्रदर्शन",
        "install_now": "अब इंस्टॉल करें",
        "later": "बाद में",
        "please_see_below_for_a_list_of_changes_to_the_features": "कृपया नीचे सुविधाओं में किए गए परिवर्तनों की सूची देखें",
        "to_integrate_new_services_into_an_alian_hub": "हाइफन ओआई प्रो में नई सेवाओं को एकीकृत करने के लिए",
        "whats_new": "क्या नया है?",
        "check_to_agree_with_above_points": "ऊपर दिए गए बिंदुओं से सहमत होने के लिए चेक करें",
        "general_notes": "सामान्य नोट्स",
        "update_now": "अब अपडेट करें",
        "unlock_channel": "चैनल अनलॉक करने के लिए",
        "unlock_chat": "चैट अनलॉक करने के लिए",
        "unlock_one_chat": "एक से एक चैट अनलॉक करने के लिए",
        "public_private_creation_time_limit_reached": "आप परियोजना निर्माण की सीमा तक पहुँच चुके हैं। यदि आप एक परियोजना बनाना चाहते हैं, तो कृपया अपनी योजना अपग्रेड करें।",
        "public_creation_time_limit_reached": "आप सार्वजनिक परियोजना निर्माण की सीमा तक पहुँच चुके हैं। आप केवल निजी परियोजनाएँ बना सकते हैं। यदि आप एक सार्वजनिक परियोजना बनाना चाहते हैं, तो कृपया अपनी योजना अपग्रेड करें।",
        "private_creation_time_limit_reached": "आप निजी परियोजना निर्माण की सीमा तक पहुँच चुके हैं। आप केवल सार्वजनिक परियोजनाएँ बना सकते हैं। यदि आप एक निजी परियोजना बनाना चाहते हैं, तो कृपया अपनी योजना अपग्रेड करें।"
    },
    "Permissions": {
        "advanced_permission": "उन्नत अनुमतियाँ",
        "allow_admins": "एडमिन को निजी स्थानों को प्रबंधित करने की अनुमति दें",
        "when_admin_enable": "जब सक्षम किया जाता है, एडमिन सभी स्थानों में लोगों को जोड़ने/हटाने और स्वामित्व स्थानांतरित करने में सक्षम होंगे",
        "show_all_projects": "सभी प्रोजेक्ट्स दिखाएं",
        "when_user_enable": "जब सक्षम किया जाता है, उपयोगकर्ता सभी वैश्विक प्रोजेक्ट्स देख सकेंगे",
        "show_all_task": "सभी कार्य दिखाएं",
        "when_user_enable_sprint": "जब सक्षम किया जाता है, उपयोगकर्ता सभी कार्यों को स्प्रिंट में देख सकेंगे",
        "own": "स्वयं का",
        "select": "चुनें",
        "Member": "सदस्य",
        "Guest": "अतिथि",
        "None": "कोई नहीं",
        "Read": "पढ़ें",
        "add_new_team": "नई टीम जोड़ें",
        "Read & Write": "पढ़ें और लिखें",
        "Support": "समर्थन",
        "select_priorities": "प्राथमिकताएँ चुनें",
        "apply_permission": "अनुमति लागू करें",
        "project_permission_description": "वैश्विक अनुमतियों को ओवरराइड करने के लिए, यह डिफ़ॉल्ट रूप से अक्षम है। इसे सक्षम करने के बाद, आप प्रोजेक्ट और कार्य अनुमतियाँ प्रबंधित कर सकते हैं। अगर इसे अक्षम किया जाता है, तो वैश्विक अनुमतियाँ लागू होती हैं",
        "project_permission_title_disable": "इस प्रोजेक्ट के लिए कस्टम अनुमतियाँ प्रदान करने की क्षमता अक्षम की जाएगी",
        "project_permission_title_enable": "इस प्रोजेक्ट के लिए कस्टम अनुमतियाँ प्रदान करने की क्षमता सक्षम की जाएगी",
        "reset_permission": "अनुमति को रीसेट करें"
    },
    "subProjectRulesNames": {
        "Project_List": "प्रोजेक्ट सूची",
        "Project_Create": "प्रोजेक्ट बनाएं",
        "Project_Name_Edit": "प्रोजेक्ट नाम संपादित करें",
        "Project_Sprint_Create": "प्रोजेक्ट स्प्रिंट बनाएं",
        "Project_folder_Create": "प्रोजेक्ट फ़ोल्डर बनाएं",
        "Project_folder_Name_Edit": "प्रोजेक्ट फ़ोल्डर नाम संपादित करें",
        "Project_sprint_Name_Edit": "प्रोजेक्ट स्प्रिंट नाम संपादित करें",
        "Project_Details": "प्रोजेक्ट विवरण",
        "Project_Status_Change": "प्रोजेक्ट स्थिति बदलें",
        "Project_Assignee": "प्रोजेक्ट असाइन करें",
        "Project_Category": "प्रोजेक्ट श्रेणी",
        "Proejct_Source": "प्रोजेक्ट स्रोत",
        "Project_Type": "प्रोजेक्ट प्रकार",
        "Project_Currency": "प्रोजेक्ट मुद्रा",
        "Project_Amount": "प्रोजेक्ट राशि",
        "Project_Start Date": "प्रोजेक्ट प्रारंभ तिथि",
        "Project_End Date": "प्रोजेक्ट समाप्ति तिथि",
        "Project_Due Date": "प्रोजेक्ट नियत तिथि",
        "Project_Close": "प्रोजेक्ट बंद करें",
        "Project_Description": "प्रोजेक्ट विवरण",
        "Project_Checklist": "प्रोजेक्ट चेकलिस्ट",
        "Project_Checklist_Assign/remove": "प्रोजेक्ट चेकलिस्ट असाइन/हटाएं",
        "Project_Attachments": "प्रोजेक्ट अटैचमेंट्स",
        "Project_Milestone": "प्रोजेक्ट माइलस्टोन",
        "Task_list": "कार्य सूची",
        "Task_Create": "कार्य बनाएं",
        "Sub_Task_Create": "उपकार्य बनाएं",
        "Task_Name_Edit": "कार्य नाम संपादित करें",
        "Task_Status": "कार्य स्थिति",
        "Task_Assignee": "कार्य असाइन करें",
        "Task_Priority": "कार्य प्राथमिकता",
        "Task_Due_Date": "कार्य नियत तिथि",
        "Task_Estimated_Hours": "कार्य अनुमानित घंटे",
        "Task_Description": "कार्य विवरण",
        "Task_Checklist": "कार्य चेकलिस्ट",
        "Task_Checklist_Assign/remove": "कार्य चेकलिस्ट असाइन/हटाएं",
        "Task_Attachments": "कार्य अटैचमेंट्स",
        "Show_Tasks": "कार्य दिखाएं",
        "Custom_Field": "कस्टम फ़ील्ड",
        "Edit_Company": "कंपनी संपादित करें",
        "File_Extensions": "फाइल एक्सटेंशन्स",
        "Project_Milestone_Status": "प्रोजेक्ट माइलस्टोन स्थिति",
        "Invite_Member": "सदस्य आमंत्रित करें",
        "Member_list": "सदस्य सूची",
        "Create_Team": "टीम बनाएं",
        "Team_List": "टीम सूची",
        "Security_&_Permissions": "सुरक्षा और अनुमतियाँ",
        "Role_Management": "भूमिका प्रबंधन",
        "Designation": "पदनाम",
        "Milestone_Weekly_Range": "माइलस्टोन साप्ताहिक सीमा",
        "User_Timesheet": "उपयोगकर्ता टाइमशीट",
        "Project_Timesheet": "प्रोजेक्ट टाइमशीट",
        "Workload__Timesheet": "वर्कलोड टाइमशीट",
        "Milestone_Report": "माइलस्टोन रिपोर्ट",
        "Project": "प्रोजेक्ट",
        "Task": "कार्य",
        "Company_Settings": "कंपनी सेटिंग्स",
        "Sheet_Settings": "शीट सेटिंग्स",
        "Team_Color": "टीम रंग",
        "Team_Name": "टीम नाम",
        "Add_Member": "सदस्य जोड़ें",
        "Add_New_Designation": "नया पदनाम जोड़ें"
    },
    "Notification": {
        "Notification": "सूचना",
        "notification_setting": "सूचना सेटिंग्स",
        "browser": "ब्राउज़र",
        "mobile": "मोबाइल",
        "before": "पहले",
        "chat": "चैट",
        "project": "प्रोजेक्ट",
        "tasks": "कार्य",
        "before_project_due_date": "प्रोजेक्ट नियत तिथि से पहले",
        "before_project_end_date": "प्रोजेक्ट समाप्ति तिथि से पहले",
        "before_task_due_date": "कार्य नियत तिथि से पहले",
        "before_task_end_date": "कार्य समाप्ति तिथि से पहले",
        "message_create": "संदेश बनाएं",
        "project_create": "प्रोजेक्ट बनाएं",
        "project_name": "प्रोजेक्ट नाम",
        "project_status_change": "प्रोजेक्ट स्थिति बदलें",
        "project_assignee": "प्रोजेक्ट असाइन करें",
        "project_lead": "प्रोजेक्ट लीड",
        "project_category": "प्रोजेक्ट श्रेणी",
        "project_source": "प्रोजेक्ट स्रोत",
        "project_type": "प्रोजेक्ट प्रकार",
        "project_currency": "प्रोजेक्ट मुद्रा",
        "project_amount": "प्रोजेक्ट राशि",
        "project_start_date": "प्रोजेक्ट प्रारंभ तिथि",
        "project_end_date": "प्रोजेक्ट समाप्ति तिथि",
        "project_due_date": "प्रोजेक्ट नियत तिथि",
        "project_close": "प्रोजेक्ट बंद करें",
        "project_description": "प्रोजेक्ट विवरण",
        "project_checklist": "प्रोजेक्ट चेकलिस्ट",
        "project_checklist_assign": "प्रोजेक्ट चेकलिस्ट असाइन करें",
        "project_checklist_remove": "प्रोजेक्ट चेकलिस्ट हटाएं",
        "project_attachments": "प्रोजेक्ट अटैचमेंट्स",
        "project_milestone": "प्रोजेक्ट माइलस्टोन",
        "project_milestone_status_change": "प्रोजेक्ट माइलस्टोन स्थिति बदलें",
        "project_sprint_create": "प्रोजेक्ट स्प्रिंट बनाएं",
        "project_folder_create": "प्रोजेक्ट फ़ोल्डर बनाएं",
        "comments_im_@mentioned_in": "टिप्पणियाँ जहां मुझे {'@'}मेंटन किया गया हो",
        "task_notification": "कार्य सूचना",
        "task_create": "कार्य बनाएं",
        "task_edit": "कार्य संपादित करें",
        "task_status": "कार्य स्थिति",
        "task_assignee": "कार्य असाइन करें",
        "task_priority": "कार्य प्राथमिकता",
        "task_type": "कार्य प्रकार",
        "task_due_date": "कार्य नियत तिथि",
        "task_description": "कार्य विवरण",
        "task_checklist": "कार्य चेकलिस्ट",
        "task_checklist_assign": "कार्य चेकलिस्ट असाइन करें",
        "task_checklist_remove": "कार्य चेकलिस्ट हटाएं",
        "task_attachments": "कार्य अटैचमेंट्स",
        "comments_Im_@mentioned_in": "टिप्पणियाँ जहां मुझे {'@'}मेंटन किया गया हो",
        "logged_hours_notification": "लॉग किए गए घंटों की सूचना",
        "after_3_hours_today_pending_hours": "आज के 3 घंटे बाद लंबित घंटों की लॉग सूचना",
        "task_estimated_hours": "कार्य अनुमानित घंटे"
    },
    "TimeTracker": {
        "TimeTracker": "समय ट्रैकर",
        "unlock": "हाइफन ओआई प्रो ट्रैकर के साथ अपने डेस्कटॉप पर ब्रह्मांड को अनलॉक करें!",
        "smooth": "समय ट्रैकिंग के साथ परियोजनाओं या कार्यों पर काम करते समय उपयोगकर्ताओं द्वारा खर्च किए गए घंटों को आसानी से ट्रैक करें।",
        "click": "क्लिक करें",
        "No_Record_Found": "कोई रिकॉर्ड नहीं मिला",
        "total": "कुल",
        "screenshot_preview": "स्क्रीनशॉट पूर्वावलोकन",
        "log_time_found_no_screenshot": "समय लॉग किया गया था, लेकिन इस अवधि के लिए कोई स्क्रीनशॉट कैप्चर नहीं किया गया।"
    },
    "settingslider": {
        "Time Tracking": "समय ट्रैकिंग",
        "Notifications": "सूचनाएं",
        "Company": "कंपनी",
        "My Settings": "मेरी सेटिंग्स",
        "Security & Permissions": "सुरक्षा और अनुमति",
        "Upgrade": "अपग्रेड करें",
        "Custom Field Manager": "कस्टम फ़ील्ड प्रबंधक",
        "Templates": "टेम्पलेट्स",
        "Projects": "प्रोजेक्ट्स",
        "Teams": "टीमें",
        "Members": "सदस्य",
        "Settings": "सेटिंग्स",
        "Change Password": "पासवर्ड बदलें"
    },
    "Chat": {
        "welcome_message": "BRAND_NAME में स्वागत है",
        "msg2": "यह एक नया समूह है। यहां कुछ कदम दिए गए हैं जो आपको शुरू करने में मदद करेंगे। अधिक जानकारी के लिए, हमारे गेटिंग स्टार्टेड गाइड को देखें",
        "chats": "चैट्स",
        "favorites": "पसंदीदा",
        "CHANNELS": "चैनल्स"
    },
    "Comments": {
        "unread_message": "अवाचित संदेश",
        "more": "अधिक",
        "less": "कम",
        "edited": "संपादित",
        "edit": "संपादित करें",
        "create_task": "कार्य बनाएं",
        "add_to_checklist": "चेकलिस्ट में जोड़ें",
        "copy_message": "संदेश कॉपी करें",
        "reply": "उत्तर दें",
        "message": "संदेश",
        "mark_unread": "अवाचित के रूप में चिह्नित करें",
        "This_message_is_deleted": "यह संदेश हटा दिया गया है",
        "You_deleted_this_message": "आपने यह संदेश हटा दिया है",
        "no_user_found": "कोई उपयोगकर्ता नहीं मिला",
        "unlock_comment_view": "टिप्पणी दृश्य अनलॉक करने के लिए"
    },
    "PlaceHolder": {
        "enter_task_type": "कार्य प्रकार दर्ज करें",
        "enter_task_status": "कार्य स्थिति दर्ज करें",
        "enter_project_status": "प्रोजेक्ट स्थिति दर्ज करें",
        "Enter_Project_Name": "प्रोजेक्ट नाम दर्ज करें",
        "Enter_Key_Name": "कुंजी नाम दर्ज करें",
        "Select_Category": "वर्ग चुनें",
        "Select_Project_Due_Date": "प्रोजेक्ट की ड्यू तिथि चुनें",
        "search": "खोजें",
        "search_here": "यहां खोजें",
        "Type_here": "यहां टाइप करें",
        "Task_name": "कार्य का नाम",
        "Add_description": "विवरण जोड़ें",
        "Enter_Duplicate_Task_Name": "डुप्लिकेट कार्य नाम दर्ज करें",
        "Enter_Text": "पाठ दर्ज करें",
        "Enter_Amount": "राशि दर्ज करें",
        "Select": "चुनें",
        "Enter_Refund_Amount": "रिफंड राशि दर्ज करें",
        "Enter_Milestone_Name": "माइलस्टोन नाम दर्ज करें",
        "Enter_sprint_name": "स्प्रिंट नाम दर्ज करें",
        "Enter_directory_name": "निर्देशिका नाम दर्ज करें",
        "Rename_Tag": "टैग का नाम बदलें",
        "Enter_Team_Name": "टीम का नाम दर्ज करें",
        "Duration_only_hours": "सिर्फ घंटे की अवधि",
        "Enter_option": "विकल्प दर्ज करें",
        "Enter_View_Name": "व्यू नाम दर्ज करें",
        "Enter_URL": "यूआरएल दर्ज करें",
        "Enter_HTML": "एचटीएमएल दर्ज करें",
        "Enter_item_name": "+ आइटम नाम दर्ज करें",
        "Add_an_item": "+ एक आइटम जोड़ें",
        "Enter_Company_Name": "कंपनी का नाम दर्ज करें",
        "Select_Country": "देश चुनें",
        "Enter_Template": "टेम्पलेट दर्ज करें",
        "Enter_Template_Name": "टेम्पलेट नाम दर्ज करें",
        "Project_key_must_be_unique": "प्रोजेक्ट कुंजी अद्वितीय होनी चाहिए",
        "Enter_zip": "ज़िप दर्ज करें",
        "Enter_GST_Number": "जीएसटी नंबर दर्ज करें",
        "Enter_Milestone_Status": "माइलस्टोन स्थिति दर्ज करें",
        "Enter_Priority_Name": "प्राथमिकता नाम दर्ज करें",
        "Enter_File_Extensions_Name": "फाइल एक्सटेंशन नाम दर्ज करें",
        "Enter_Task_Name": "कार्य का नाम दर्ज करें",
        "Select_State": "राज्य चुनें",
        "No_States": "कोई राज्य नहीं",
        "Select_City": "शहर चुनें",
        "No_Cities": "कोई शहर नहीं",
        "enter_category_name": "वर्ग नाम दर्ज करें",
        "enter_channel_name": "चैनल नाम दर्ज करें",
        "Pinned_messages": "पिन किए गए संदेश",
        "Search": "खोजें",
        "Search_by_name_or_email": "नाम या ईमेल से खोजें",
        "Invite_by_email": "ईमेल द्वारा निमंत्रण भेजें",
        "Select_Designation": "पदनाम चुनें",
        "Select_Role": "भूमिका चुनें",
        "Enter_designation": "पदनाम दर्ज करें",
        "Enter_Description": "विवरण दर्ज करें",
        "Add_New_Role": "नई भूमिका जोड़ें",
        "Enter_role": "भूमिका दर्ज करें",
        "Enter_Field_Label": "फील्ड लेबल दर्ज करें",
        "Enter_Placeholder": "प्लेसहोल्डर दर्ज करें",
        "field_label": "फील्ड लेबल",
        "placeholder": "प्लेसहोल्डर",
        "Enter_Number": "संख्या दर्ज करें"
    },
    "DuplicateTask": {
        "duplicate_task_name": "डुप्लिकेट कार्य नाम",
        "what_do_you_copy": "आप क्या कॉपी करना चाहते हैं",
        "everything": "सभी चीजें",
        "no_assignee": "कोई असाइन नहीं",
        "no_watcher": "कोई वॉचर नहीं",
        "move_task": "कार्य को स्थानांतरित करें",
        "mearge_task_into": "कार्य को में मर्ज करें"
    },
    "Converttolist": {
        "are_you_sure_convert": "क्या आप सुनिश्चित हैं कि आप इस कार्य को सूची में परिवर्तित करना चाहते हैं?",
        "important": "महत्वपूर्ण",
        "you_will_lose": "आप सभी थ्रेडेड टिप्पणियां खो देंगे। यह क्रिया वापस नहीं की जा सकती",
        "convert_to_list": "सूची में परिवर्तित करें"
    },
    "Billing": {
        "billing_details": "बिलिंग विवरण",
        "plan_details": "योजना विवरण",
        "next_msg": "अगला देय राशि है",
        "due_on": "देय तिथि",
        "upgrade_plan": "योजना अपग्रेड करें",
        "cancel_subscription": "सदस्यता रद्द करें",
        "reactivate_subscription": "सदस्यता फिर से सक्रिय करें",
        "biling_info": "बिलिंग जानकारी",
        "update_billing_info": "बिलिंग जानकारी अपडेट करें",
        "contact_support": "सहायता से संपर्क करें",
        "for_help_msg": "अपने बिलिंग सवालों में मदद और समर्थन के लिए, हमारी सहायता टीम से संपर्क करें और वे आपकी मदद करने में खुशी महसूस करेंगे।",
        "payment_methods": "भुगतान विधियाँ",
        "update_payment_method": "भुगतान विधि अपडेट करें",
        "add_payment_method": "भुगतान विधि जोड़ें",
        "ending_in": "में समाप्त हो रहा है",
        "payment_method_update": "भुगतान विधि अपडेट सफलतापूर्वक।",
        "waiting_msg": "आपके हाल ही में किए गए भुगतान विधि अपडेट को अगली बिलिंग में प्रभावी किया जाएगा और सभी भविष्य के भुगतान के लिए इसका उपयोग किया जाएगा।",
        "error_updating": "भुगतान विधि अपडेट असफल। हमें भुगतान विधि अपडेट करते समय समस्या आई। कृपया पुनः प्रयास करें या सहायता के लिए संपर्क करें।",
        "card_expires": "कार्ड समाप्त होता है",
        "billing_address": "बिलिंग पता",
        "subscription_plan": "सदस्यता योजना",
        "next_renew_date": "अगली नवीनीकरण तिथि",
        "storage_use": "संग्रहण उपयोग",
        "address": "पता",
        "address_line": "पता पंक्ति",
        "zip_code": "ज़िप कोड",
        "zip": "ज़िप",
        "Save_&_Continue": "सहेजें और जारी रखें",
        "billing_history": "बिलिंग इतिहास",
        "Invoices": "चालान",
        "credit_notes": "क्रेडिट नोट्स",
        "download": "डाउनलोड",
        "id": "पहचान",
        "type": "प्रकार",
        "date": "तारीख",
        "description": "विवरण",
        "no_of_users": "उपयोगकर्ताओं की संख्या",
        "amount": "राशि",
        "status": "स्थिति",
        "pay_now": "अभी भुगतान करें",
        "cancelling_subscription_message": "सदस्यता रद्द करने का मतलब है कि आपकी सदस्यता समाप्त हो जाएगी",
        "reactivate_anytime": "कभी भी पुनः सक्रिय करें!",
        "reactivate_confirmation": "क्या आप सुनिश्चित हैं कि आप सदस्यता को फिर से सक्रिय करना चाहते हैं? 'हां' का चयन करने पर आप सदस्यता को पुनः सक्रिय कर लेंगे और आपकी बिलिंग फिर से शुरू हो जाएगी।",
        "amounting_to": "राशि के बराबर",
        "insufficient_funds": "अपर्याप्त निधि",
        "payment_successful": "भुगतान सफलतापूर्वक हुआ।",
        "payment_successful_details": "भुगतान सफल! आपका चालान भुगतान हो चुका है। कृपया 2 से 3 मिनट का समय दें ताकि परिवर्तन हर जगह प्रभावी हो जाएं और आप विस्तारित सुविधाओं और सुधारों का पूर्ण रूप से आनंद ले सकें!",
        "payment_unsuccessful": "भुगतान असफल। हमें आपकी योजना अपग्रेड करते समय समस्या आई। कृपया पुनः प्रयास करें या सहायता के लिए संपर्क करें।",
        "plan_upgrade_unsuccessful": "योजना अपग्रेड असफल। हमें आपकी योजना अपग्रेड करते समय समस्या आई। कृपया सुनिश्चित करें कि कार्ड में पर्याप्त बैलेंस हो।",
        "proceed_with_payment": "क्या आप चालान संख्या के लिए भुगतान करना जारी रखना चाहते हैं",
        "attention_needed": "हमें आपकी ध्यान की आवश्यकता है!",
        "avoid_service_disruption": "सेवा विघटन से बचने के लिए",
        "subscription_renewal_failed": "सदस्यता स्वचालित नवीनीकरण विफल रहा है",
        "update_payment_method_please": "कृपया अपनी भुगतान विधि अपडेट करें",
        "click_here_for_update_payment_method": "भुगतान विधि अपडेट करने के लिए यहां क्लिक करें",
        "credit_balance": "क्रेडिट बैलेंस",
        "this_balance_will_be_used_for_a_future_payment": "यह बैलेंस भविष्य के भुगतान के लिए उपयोग किया जाएगा।",
        "paymnet_failed_subscription_canceled": "हम आपको सूचित करना चाहते हैं कि आपकी पिछली सदस्यता रद्द कर दी गई है। आपका खाता अब हमारी डिफ़ॉल्ट सदस्यता में स्थानांतरित कर दिया गया है, जिसमें कुछ सुविधाएँ अक्षम हैं। इन सुविधाओं को सक्षम करने के लिए, कृपया अपनी योजना अपग्रेड करें।",
        "promotional_credit_balance": "प्रचार क्रेडिट",
        "balance": "शेष राशि",
        "created_on": "निर्माण तिथि",
        "no_promotional_found": "कोई प्रचार क्रेडिट इतिहास नहीं मिला"
    },
    "Tour": {
        "tour_completed": "टूर पूरा हुआ",
        "do_you_have_any": "क्या आपके पास कोई सवाल हैं? हम आपको BRAND_NAME के हमारे व्यापक वीडियो ट्यूटोरियल्स को देखने के लिए प्रोत्साहित करते हैं, ताकि आप शुरुआत कर सकें और अपने अनुभव का अधिकतम लाभ उठा सकें।",
        "watch_video": "वीडियो देखें",
        "have_brief_tour_alianhub": "क्या आपने BRAND_NAME का संक्षिप्त टूर किया है?",
        "have_brief_tour_alianhub_view": "क्या आपने BRAND_NAME दृश्य का संक्षिप्त टूर किया है?",
        "have_brief_tour_alianhub_left_side": "क्या आपने प्रोजेक्ट सूची का संक्षिप्त टूर किया है?",
        "look_how_to_create": "देखें कि कैसे प्रोजेक्ट बनाएं, कार्यों का प्रबंधन करें, टाइम शीट रिपोर्ट्स देखें, चैट में प्रवेश करें, उल्लेख और सूचनाओं को देखें, और बहुत कुछ।",
        "lets_start": "आइए शुरू करें",
        "no_thanks": "नहीं धन्यवाद",
        "have_brief_task": "क्या आपने कार्य का संक्षिप्त टूर किया है?",
        "have_brief_tour_project": "क्या आपने प्रोजेक्ट का संक्षिप्त टूर किया है?",
        "look_how_to_create_task": "देखें कि कैसे कार्य बनाएं, कार्य का प्रबंधन करें, स्थिति समूह के अनुसार कार्यों को देखें और बहुत कुछ।",
        "look_how_to_create_project": "देखें कि कैसे प्रोजेक्ट बनाएं, प्रोजेक्ट का प्रबंधन करें, स्थिति समूह के अनुसार कार्यों को देखें और बहुत कुछ।",
        "project_creation_description": "प्रोजेक्ट को आसानी से बनाया, सौंपा और ट्रैक किया जा सकता है, जिसमें टीम के सदस्यों की जिम्मेदारियों की स्पष्ट दृश्यता होती है। इससे बेहतर संगठन में मदद मिलती है, जिससे कार्यक्षमता और उत्पादकता बढ़ती है। नया प्रोजेक्ट शुरू करने के लिए यहां क्लिक करें।",
        "enter_project_name": "कृपया अपने प्रोजेक्ट के लिए एक संक्षिप्त नाम दर्ज करें।",
        "enter_project_key": "कृपया अपने प्रोजेक्ट के लिए एक संक्षिप्त कुंजी दर्ज करें।",
        "add_project_category": "कृपया अपने प्रोजेक्ट के लिए एक श्रेणी जोड़ें।",
        "enter_project_duedate": "कृपया अपने प्रोजेक्ट के लिए एक ड्यू डेट दर्ज करें।",
        "add_project_lead_assignee": "कृपया अपने प्रोजेक्ट के लिए लीड असाइन करें।",
        "create_project_from_template": "यह विकल्प आपको मौजूदा टेम्पलेट का उपयोग करके जल्दी से नया प्रोजेक्ट बनाने की सुविधा देता है, जिसमें पूर्वनिर्धारित डेटा और सेटिंग्स होती हैं, जिससे आप आसानी से वही प्रोजेक्ट सेटअप दोहरा सकते हैं।",
        "customize_project_section": "यह विकल्प आपको अपने प्रोजेक्ट को पूरी तरह से वैयक्तिकृत करने की अनुमति देता है, जैसे स्थिति, प्रकार, ऐप्स और अन्य तत्वों को सेट करके जो आपकी विशिष्ट आवश्यकताओं को पूरा करते हैं।",
        "task_type_templates_list_text": "कार्य प्रकार टेम्पलेट्स सूची",
        "task_type_templates_description_text": "यह अनुभाग उपलब्ध कार्य प्रकार टेम्पलेट्स को प्रदर्शित करता है। अपनी आवश्यकताओं के अनुसार उपयुक्त टेम्पलेट का चयन करें।",
        "create_new_task_type_template_text": "नया कार्य प्रकार टेम्पलेट बनाएं",
        "create_new_task_type_template_description_text": "नया कार्य प्रकार टेम्पलेट जोड़ने के लिए + बटन पर क्लिक करें, जिसे आप बाद में अपने कार्यों के लिए उपयोग कर सकते हैं।",
        "view_template_task_types_text": "टेम्पलेट कार्य प्रकार देखें",
        "view_template_task_types_description_text": "यहां आप चयनित टेम्पलेट से जुड़े कार्य प्रकार देख सकते हैं। आप अपनी आवश्यकताओं के अनुसार कार्य प्रकार को संशोधित या नया जोड़ सकते हैं।",
        "add_new_task_type_text": "नया कार्य प्रकार जोड़ें",
        "add_new_task_type_description_text": "'Add Task Type' बटन पर क्लिक करके चयनित टेम्पलेट में नए कार्य प्रकार जोड़ें।",
        "save_project_as_template_text": "प्रोजेक्ट को टेम्पलेट के रूप में सहेजें",
        "save_project_as_template_description_text": "इस बटन पर क्लिक करके आप वर्तमान सेटअप को भविष्य के प्रोजेक्ट्स के लिए सहेज सकते हैं।",
        "initiate_new_project_text": "नया प्रोजेक्ट शुरू करें",
        "initiate_new_project_description_text": "यहां क्लिक करें और नया प्रोजेक्ट शुरू करें।",
        "add_new_task_text": "नया कार्य जोड़ें",
        "input_task_name_text": "कार्य का नाम दर्ज करें",
        "choose_task_status_text": "कार्य की स्थिति चुनें",
        "assign_task_text": "कार्य सौंपें",
        "set_task_deadline_text": "कार्य की डेडलाइन सेट करें",
        "define_task_priority_text": "कार्य की प्राथमिकता निर्धारित करें",
        "view_task_list_text": "कार्य सूची देखें",
        "task_information_text": "कार्य जानकारी",
        "quick_task_menu_text": "क्विक कार्य मेनू",
        "task_actions_text": "कार्य क्रियाएं",
        "subtask_toggle_text": "उपकार्य टॉगल",
        "task_tour_complete_text": "कार्य टूर पूरा",
        "create_new_task_description_text": "नया कार्य बनाने के लिए '+ New Task' बटन पर क्लिक करें।",
        "input_task_name_description_text": "दिए गए इनपुट क्षेत्र में कार्य का नाम दर्ज करें।",
        "choose_task_status_description_text": "अपनी आवश्यकताओं के अनुसार उपयुक्त कार्य प्रकार का चयन करें।",
        "assign_task_description_text": "जिस व्यक्ति को कार्य सौंपना है, उसे चुनें।",
        "set_task_deadline_description_text": "कार्य के लिए एक ड्यू डेट चुनें।",
        "define_task_priority_description_text": "कार्य के लिए प्राथमिकता स्तर चुनें।",
        "view_task_list_description_text": "यह कार्यों की सूची है, जो उनकी स्थिति के अनुसार समूहित और उनके विवरण दिखाती है।",
        "task_information_description_text": "यहां चयनित कार्य के विवरण हैं।",
        "quick_task_menu_description_text": "आइकन पर क्लिक करने से कार्य संचालन विकल्पों के साथ एक ड्रॉपडाउन मेनू खुल जाएगा।",
        "task_actions_description_text": "उपलब्ध कार्य संचालन में से एक क्रिया का चयन करें।",
        "subtask_toggle_description_text": "यहां उपकार्य की सूची को दिखाने के लिए एक टॉगल है।",
        "task_tour_complete_description_text": "टूर पूरा हो चुका है। अब आप आने वाले संभावनाओं का अन्वेषण करना शुरू करें!",
        "search_and_filter_projects_text": "प्रोजेक्ट्स को खोजें और फ़िल्टर करें",
        "search_projects_text": "प्रोजेक्ट्स खोजें",
        "search_options_for_projects_text": "प्रोजेक्ट्स के लिए खोज विकल्प",
        "search_projects_by_name_text": "प्रोजेक्ट्स को नाम से खोजें",
        "advanced_project_search_text": "उन्नत प्रोजेक्ट खोज",
        "filter_projects_by_favorites_text": "फेवरेट्स द्वारा प्रोजेक्ट्स को फ़िल्टर करें",
        "project_settings_text": "प्रोजेक्ट सेटिंग्स",
        "project_list_text": "प्रोजेक्ट सूची",
        "end_of_project_view_tour_text": "प्रोजेक्ट दृश्य टूर का अंत",
        "search_and_filter_projects_description_text": "यहां अपने मानदंडों के आधार पर प्रोजेक्ट्स को खोजें और फ़िल्टर करें।",
        "enter_search_keywords_text": "विशिष्ट प्रोजेक्ट्स खोजने के लिए खोज शब्द दर्ज करें।",
        "search_filter_dropdown_description_text": "खोज फ़िल्टर के साथ एक ड्रॉपडाउन मेनू खोलने के लिए आइकन पर क्लिक करें।",
        "toggle_search_options_description_text": "जब आप टाइप करें, तो प्रोजेक्ट, स्प्रिंट, या फ़ोल्डर द्वारा खोजने के लिए विकल्पों के बीच स्विच करें।",
        "advanced_search_icon_description_text": "उन्नत खोज संचालन करने के लिए आइकन पर क्लिक करें।",
        "filter_by_favorites_description_text": "पसंदीदा प्रोजेक्ट्स को सूची के शीर्ष पर प्राथमिकता देने के लिए स्टार आइकन पर क्लिक करें।",
        "project_settings_icon_description_text": "सेटिंग्स आइकन पर क्लिक करके आप संग्रहित या अप्रतिबंधित प्रोजेक्ट विकल्पों के बीच स्विच कर सकते हैं।",
        "view_project_list_description_text": "यहां, आप अपने प्रोजेक्ट्स की सूची देख सकते हैं।",
        "end_of_project_view_tour_description_text": "टूर अब पूरा हो गया है।",
        "create_assign_prioritize_monitor_projects_text": "आसानी से प्रोजेक्ट्स बनाएं, सौंपें, प्राथमिकता निर्धारित करें और निगरानी रखें। टीम के सदस्य अपने कार्यों को स्पष्ट रूप से देख सकते हैं, व्यवस्थित रह सकते हैं और कार्यक्षमता और उत्पादकता बढ़ा सकते हैं। नया प्रोजेक्ट शुरू करने के लिए यहां क्लिक करें।",
        "track_users_time_sheet_reports_text": "विभिन्न टाइम शीट रिपोर्ट्स जैसे यूजर टाइम शीट, प्रोजेक्ट टाइम शीट, वर्कलोड टाइम शीट, और ट्रैकर टाइमशीट के माध्यम से यूजर्स का समय प्रभावी ढंग से ट्रैक करें। टाइम शीट रिपोर्ट्स देखने के लिए यहां क्लिक करें।",
        "user_time_sheet_description_text": "यूजर टाइम शीट आपको प्रत्येक उपयोगकर्ता द्वारा लॉग की गई घंटों को आपके यूजर रोल के अनुसार मॉनिटर करने की सुविधा देती है।",
        "project_time_sheet_description_text": "प्रोजेक्ट टाइम शीट में आपके यूजर रोल के आधार पर प्रत्येक प्रोजेक्ट के लिए लॉग की गई घंटों का ट्रैक रखें।",
        "workload_time_sheet_description_text": "यूजर टाइम शीट के समान, वर्कलोड टाइम शीट में यूजर के कार्यभार, कुल घंटे, और अनुमानित घंटों की जानकारी भी शामिल होती है।",
        "tracker_sheet_description_text": "ट्रैकर शीट समय ट्रैकर के माध्यम से लॉग किए गए समय को, साथ ही स्क्रीनशॉट्स और कुल ट्रैक किए गए समय को दिखाती है।",
        "view_companies_switch_text": "सभी कंपनियां देखें जिनसे आप जुड़े हुए हैं और उन्हें एक को चुनकर आसानी से स्विच करें।",
        "engage_team_real_time_text": "त्वरित निर्णय लेने के लिए टीम के सदस्यों के साथ वास्तविक समय में जुड़ें। चैनल बनाएं और अटैचमेंट्स, वॉयस मैसेजेस और टेक्स्ट के माध्यम से जानकारी साझा करें।",
        "real_time_notifications_text": "प्रोजेक्ट और कार्य गतिविधियों के बारे में वास्तविक समय में सूचनाओं के साथ अद्यतन रहें, जिसमें कार्य असाइनमेंट, स्थिति परिवर्तन, टिप्पणियां, और डेडलाइन्स शामिल हैं।",
        "address_specific_individuals_text": "प्रोजेक्ट प्रबंधन प्रणाली में विशिष्ट व्यक्तियों को सीधे संबोधित करें। कार्यों, प्रोजेक्ट्स या चर्चाओं से संबंधित उल्लेखों को देखें।",
        "access_personal_information_text": "आपकी व्यक्तिगत जानकारी तक पहुंच प्राप्त करें, साथ ही कंपनियों, प्रोजेक्ट्स, उपयोगकर्ताओं, और सुरक्षा से संबंधित सेटिंग्स, जो आपके यूजर रोल पर आधारित हैं।",
        "project_views_list_text": "प्रोजेक्ट दृश्य सूची",
        "add_new_project_view_text": "नया प्रोजेक्ट दृश्य जोड़ें",
        "manage_project_views_text": "प्रोजेक्ट दृश्यों का प्रबंधन करें",
        "project_files_text": "प्रोजेक्ट फ़ाइलें",
        "project_audio_files_text": "प्रोजेक्ट ऑडियो फ़ाइलें",
        "add_project_watcher_text": "प्रोजेक्ट वॉचर जोड़ें",
        "project_operation_list_text": "प्रोजेक्ट संचालन सूची",
        "advanced_task_filter_text": "उन्नत कार्य फ़िल्टर",
        "search_tasks_text": "कार्य खोजें",
        "search_options_menu_text": "खोज विकल्प मेनू",
        "search_criteria_text": "खोज मानदंड",
        "project_views_list_description_text": "उपलब्ध प्रोजेक्ट दृश्यों की सूची।",
        "add_new_project_view_description_text": "यहां एक नया दृश्य बनाएं।",
        "manage_project_views_description_text": "यहां आप प्रोजेक्ट में दृश्यों को जोड़ सकते हैं या पिन कर सकते हैं। 'View Add' पर क्लिक करके जोड़ें, या 'Pin View' का चयन करके एक दृश्य पिन करें।",
        "project_files_description_text": "आइकन पर क्लिक करके सभी प्रोजेक्ट फ़ाइलों और लिंक तक पहुंच प्राप्त करें।",
        "project_audio_files_description_text": "आइकन पर क्लिक करके प्रोजेक्ट से संबंधित सभी ऑडियो फ़ाइलें देखें।",
        "add_project_watcher_description_text": "अपने प्रोजेक्ट वॉचर सेटिंग्स का प्रबंधन करें।",
        "project_operation_list_description_text": "यहां से विभिन्न प्रोजेक्ट संचालन करें।",
        "advanced_task_filter_description_text": "उन्नत खोज संचालन करने के लिए आइकन पर क्लिक करें।",
        "search_tasks_description_text": "विशिष्ट कार्यों को खोजने के लिए प्रासंगिक कीवर्ड दर्ज करें।",
        "search_options_menu_description_text": "विभिन्न खोज विकल्पों के साथ ड्रॉपडाउन खोलने के लिए आइकन पर क्लिक करें।",
        "search_criteria_description_text": "जब आप टाइप करें, तो कार्य नाम, कार्य कुंजी, या विवरण के बीच चयन करें ताकि आप अपनी खोज को परिष्कृत कर सकें।",
        "select_operation_description_text": "प्रोजेक्ट पर इच्छित क्रिया करने के लिए एक संचालन का चयन करें।"
    },
    "TaskStatus": {
        "To_Do": "करने के लिए"
    },
    "AI": {
        "generate": "उत्पन्न करें",
        "ai_button": "AI के साथ लिखें",
        "ai_title": "AI से कुछ ढूंढने या बनाने के लिए पूछें",
        "write_with_ai": "AI के साथ लिखें",
        "suggest_tasks": "कार्य सुझाएं",
        "suggest_subtasks": "उपकार्य सुझाएं",
        "ai_sidebar_placeholder": "आप AI से क्या लिखवाना चाहेंगे?",
        "ai_chat_placeholder": "AI से अगला काम बताएं",
        "ai_available_on_paid_plans_upgrade_now": "AI केवल हमारे भुगतान किए गए योजनाओं पर उपलब्ध है। अभी अपग्रेड करें और AI जोड़ें!",
        "please_upgrade_plan_to_use_ai": "AI का उपयोग करने के लिए कृपया अपनी योजना अपग्रेड करें।",
        "read_less": "कम पढ़ें",
        "read_more": "और पढ़ें",
        "to_unlock_ai": "AI अनलॉक करने के लिए",
        "copy": "कॉपी करें",
        "generating_results": "परिणाम उत्पन्न हो रहे हैं",
        "hub_ai": "HubAi",
        "regenerate": "पुनः उत्पन्न करें",
        "title": "शीर्षक",
        "error_occurred_engine_issue": "एक त्रुटि हुई। या तो इंजन जो आपने अनुरोध किया था वह मौजूद नहीं है या आपकी अनुरोध को प्रोसेस करते समय कोई और समस्या हुई है",
        "ai_not_integrated": "AI आपके सिस्टम में एकीकृत नहीं है",
        "limit_reached": "आपने अपनी सीमा तक पहुंच चुके हैं"
    },
    "Toast": {
        "Your_card_is_expired": "आपका कार्ड समाप्त हो चुका है।",
        "Password_set_new_has_been_successfully": "नया पासवर्ड सफलतापूर्वक सेट कर दिया गया है।",
        "task_created_successfully": "कार्य सफलतापूर्वक बनाया गया",
        "please_remove_the_advanced_filter_to_view_newly_created_projects": ", कृपया नए बनाए गए परियोजनाओं को देखने के लिए उन्नत फ़िल्टर हटा दें।",
        "create_task_plan_limit_message": "अपनी योजना को अपग्रेड करें। आप TASK_SPRINT स्प्रिंट में कार्य बनाने की सीमा तक पहुँच चुके हैं।",
        "something_went_wrong": "कुछ गलत हुआ।",
        "file_size_is_larger_than_maxFileSize": "फाइल का आकार maxFileSize से अधिक है",
        "Select_image_only_and_image_file_format_should_be_FILE_FORMATS": "केवल छवि चुनें और छवि फ़ाइल प्रारूप FILE_FORMATS होना चाहिए",
        "Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS": "केवल छवि फ़ाइल चुनें और छवि फ़ाइल प्रारूप FILE_FORMATS होना चाहिए",
        "Multiple_files_not_allowed": "एकाधिक फाइलों की अनुमति नहीं है।",
        "Please_select_valid_file": "कृपया एक वैध फ़ाइल चुनें।",
        "require_image_format_message": " फ़ाइल फ़ॉर्मेट समर्थित नहीं है या कंपनी सेटिंग्स में नहीं जोड़ा गया है। आप सेटिंग्स में फ़ाइल फ़ॉर्मेट जोड़ सकते हैं।",
        "You_have_to_add_extension_in_setting": "आपको सेटिंग में विस्तार जोड़ना होगा।",
        "Something_went_wrong_Please_try_again": "कुछ गलत हुआ। कृपया फिर से प्रयास करें।",
        "Company_is_disable": "कंपनी अक्षम है",
        "advance_search_feature_upgrade_message": "वर्तमान योजना पर उन्नत खोज सुविधा उपलब्ध नहीं है। उन्नत खोज को अनलॉक करने के लिए अपनी योजना अपग्रेड करें।",
        "Access_Denied": "पहुँच अस्वीकृत",
        "notification_permission": "सूचनाएँ प्राप्त करने के लिए, कृपया साइट सेटिंग्स में सूचनाओं की अनुमति दें और पृष्ठ को फिर से लोड करें।",
        "Link_is_Copied_to_clipboard": "लिंक क्लिपबोर्ड में कॉपी किया गया",
        "Task_Key_is_Copied_to_clipboard": "कार्य कुंजी क्लिपबोर्ड में कॉपी की गई",
        "At_least_one_field_is_required": "कम से कम एक फ़ील्ड आवश्यक है।",
        "Task_name_updated_successfully": "कार्य का नाम सफलतापूर्वक अपडेट किया गया",
        "Watcher_added_successfully": "वॉचर्स सफलतापूर्वक जोड़े गए",
        "Watcher_removed_successfully": "वॉचर्स सफलतापूर्वक हटाए गए",
        "Nothing_to_update": "अपडेट करने के लिए कुछ नहीं है",
        "Sprint created successfully": "स्प्रिंट सफलतापूर्वक बनाया गया",
        "Sprint restored successfully": "स्प्रिंट सफलतापूर्वक पुनर्स्थापित किया गया",
        "Sprint closed successfully": "स्प्रिंट सफलतापूर्वक बंद किया गया",
        "Sprint archived successfully": "स्प्रिंट सफलतापूर्वक संग्रहित किया गया",
        "Sprint deleted successfully": "स्प्रिंट सफलतापूर्वक हटाया गया",
        "Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints": "अपनी योजना को अपग्रेड करें। आपने स्प्रिंट बनाने की सीमा तक पहुँच चुके हैं।",
        "Folder created successfully": "फ़ोल्डर सफलतापूर्वक बनाया गया",
        "Folder updated successfully": "फ़ोल्डर सफलतापूर्वक अपडेट किया गया",
        "Folde restored successfully": "फ़ोल्डर सफलतापूर्वक पुनर्स्थापित किया गया",
        "Folder closed successfully": "फ़ोल्डर सफलतापूर्वक बंद किया गया",
        "Folder archived successfully": "फ़ोल्डर सफलतापूर्वक संग्रहित किया गया",
        "Folder deleted successfully": "फ़ोल्डर सफलतापूर्वक हटाया गया",
        "Status_changed_successfully": "स्थिति सफलतापूर्वक बदली गई",
        "Due_date_updated_successfully": "निर्धारित तिथि सफलतापूर्वक अपडेट की गई",
        "Due_date_not_updated": "निर्धारित तिथि अपडेट नहीं हुई",
        "Assignee changed_ uccessfully": "असाइन की गई व्यक्ति सफलतापूर्वक बदली गई",
        "Assignee added successfully": "असाइन की गई व्यक्ति सफलतापूर्वक जोड़ी गई",
        "Assignee removed successfully": "असाइन की गई व्यक्ति सफलतापूर्वक हटाई गई",
        "Assignee not updated": "असाइन की गई व्यक्ति अपडेट नहीं हुई",
        "Task_updated_successfully": "कार्य सफलतापूर्वक अपडेट किया गया",
        "Task_restored_successfully": "कार्य सफलतापूर्वक पुनर्स्थापित किया गया",
        "Task_archived_successfully": "कार्य सफलतापूर्वक संग्रहित किया गया",
        "Task_deleted_successfully": "कार्य सफलतापूर्वक हटाया गया",
        "Tag_Deleted_successfully": "टैग सफलतापूर्वक हटाया गया",
        "Log_time_added_successfully": "समय लॉग सफलतापूर्वक जोड़ा गया..",
        "Filter_saved_successfully": "फ़िल्टर सफलतापूर्वक सहेजा गया।",
        "Filter_update_successfully": "फ़िल्टर सफलतापूर्वक अपडेट किया गया।",
        "Filter_deleted_successfully": "फ़िल्टर सफलतापूर्वक हटाया गया।",
        "Checklist_creted_succesfully.": "चेकलिस्ट सफलतापूर्वक बनाई गई।",
        "Please_select_checklist": "कृपया चेकलिस्ट चुनें।",
        "already_exists": "EXIST_VALUE पहले से मौजूद है",
        "Converted_sucessfully": "सफलतापूर्वक रूपांतरित किया गया",
        "create_task_limit_in_sprint_upgrade_task_message": "अपनी योजना को अपग्रेड करें। आपने SELECTED_SPRINT_DATA स्प्रिंट में कार्य बनाने की सीमा तक पहुँच चुके हैं।",
        "Please_Select_Task_Type": "कृपया कार्य प्रकार चुनें",
        "Please_Select_Task": "कृपया कार्य चुनें",
        "Task_moved_sucessfully": "कार्य सफलतापूर्वक स्थानांतरित किया गया",
        "Task_not_moved": "कार्य स्थानांतरित नहीं हुआ",
        "Task_duplicate_sucessfully": "कार्य सफलतापूर्वक डुप्लिकेट किया गया",
        "Task_not_duplicated": "कार्य डुप्लिकेट नहीं हुआ",
        "Convert_in_to_task_sucessfully": "कार्य में सफलतापूर्वक रूपांतरित किया गया",
        "Company_name_already_exists": "कंपनी का नाम पहले से मौजूद है",
        "Company_has_been_created_Successfully": "कंपनी सफलतापूर्वक बनाई गई।",
        "Custom_field_updated_successfully": "कस्टम फ़ील्ड सफलतापूर्वक अपडेट किया गया",
        "No_assignee_found": "कोई असाइन की गई व्यक्ति नहीं मिली",
        "No_due_date_found": "कोई निर्धारित तिथि नहीं मिली",
        "No_self_assignee_found": "कोई स्व-संलग्न व्यक्ति नहीं मिला",
        "Estimated_time_updated_successfully": "अनुमानित समय सफलतापूर्वक अपडेट किया गया",
        "Description_updated_successfully": "विवरण सफलतापूर्वक अपडेट किया गया",
        "Description_not_updated": "विवरण अपडेट नहीं हुआ",
        "Copied": "कॉपी किया गया!",
        "User_removed_successfully": "उपयोगकर्ता सफलतापूर्वक हटा दिया गया",
        "Invitation_cancelled_successfully": "निवेदन सफलतापूर्वक रद्द किया गया",
        "User_role_changed_successfully": "उपयोगकर्ता भूमिका सफलतापूर्वक बदली गई",
        "User_designation_changed_successfully": "उपयोगकर्ता पदनाम सफलतापूर्वक बदला गया।",
        "Please_upgrade_your_plan_to_use_Time_Tracker": "समय ट्रैकर का उपयोग करने के लिए कृपया अपनी योजना अपग्रेड करें।",
        "Request_remove_successfully": "निवेदन सफलतापूर्वक हटा दिया गया",
        "Upgrade_Your_Plan": "अपनी योजना अपग्रेड करें",
        "Updated_successfully": "सफलतापूर्वक अपडेट किया गया",
        "Deleted_successfully": "सफलतापूर्वक हटाया गया",
        "View_Pinned": "पिन किए गए दृश्य देखें",
        "View_Unpinned": "पिन न किए गए दृश्य देखें",
        "View_Already_Added": "दृश्य पहले ही जोड़ा गया है",
        "Company_details_saved_successfully": "कंपनी विवरण सफलतापूर्वक सहेजा गया।",
        "Currency_added_successfully": "मुद्रा सफलतापूर्वक जोड़ी गई",
        "Currency_removed_successfully": "मुद्रा सफलतापूर्वक हटा दी गई",
        "File_extension_remove_successfully": "फ़ाइल एक्सटेंशन FILE_EXTENSION सफलतापूर्वक हटाया गया",
        "File_extension_update_successfully": "फ़ाइल एक्सटेंशन सफलतापूर्वक अपडेट किया गया।",
        "Status_updated_successfully": "स्थिति सफलतापूर्वक अपडेट की गई",
        "Project_milestone_status_Deleted_successfully": "परियोजना मील का पत्थर स्थिति सफलतापूर्वक हटाई गई।",
        "Milestone_weekly_range_updated_successfully": "मील का पत्थर साप्ताहिक सीमा सफलतापूर्वक अपडेट की गई।",
        "Image_dimensions_should_not_exceed_ImageDimensions_pixels": "छवि आयाम ImageDimensions पिक्सल से अधिक नहीं होने चाहिए।",
        "error_in_uploading_image_please_try_it_again": "छवि अपलोड करने में त्रुटि, कृपया फिर से प्रयास करें",
        "Task_priority_updated_successfully": "कार्य प्राथमिकता सफलतापूर्वक अपडेट की गई।",
        "Task_priority_Remove_successfully": "कार्य प्राथमिकता सफलतापूर्वक हटा दी गई।",
        "Priority_updated_successfully": "प्राथमिकता सफलतापूर्वक अपडेट की गई",
        "Priority_not_updated": "प्राथमिकता अपडेट नहीं हुई",
        "error_in_deleting_priority_please_try_it_again": "प्राथमिकता हटाने में त्रुटि, कृपया फिर से प्रयास करें",
        "Field_Enable_Successfully": "फ़ील्ड सफलतापूर्वक सक्षम किया गया",
        "Field_Disable_Successfully": "फ़ील्ड सफलतापूर्वक अक्षम किया गया",
        "Field_Added_Successfully": "फ़ील्ड सफलतापूर्वक जोड़ा गया",
        "Field_Updated_Successfully": "फ़ील्ड सफलतापूर्वक अपडेट किया गया",
        "Added_to_favourite": "पसंदीदा में जोड़ा गया",
        "Removed_from_favourite": "पसंदीदा से हटा दिया गया",
        "Tag_Created_successfully": "टैग सफलतापूर्वक बनाया गया",
        "Queue list added successfully": "क्यू सूची सफलतापूर्वक जोड़ी गई",
        "Queue list removed successfully": "क्यू सूची सफलतापूर्वक हटा दी गई",
        "Queue list not updated": "क्यू सूची अपडेट नहीं हुई",
        "Attachments_uploaded_successfully": "अटैचमेंट्स सफलतापूर्वक अपलोड किए गए",
        "Attachment_removed_successfully": "अटैचमेंट सफलतापूर्वक हटा दी गई",
        "Attachment_not_removed": "अटैचमेंट नहीं हटाई गई",
        "Please_try_again": "कृपया फिर से प्रयास करें",
        "Task_name_copied": "कार्य का नाम कॉपी किया गया",
        "Status_already_exists": "स्थिति पहले से मौजूद है",
        "Status_added_sucessfully": "स्थिति सफलतापूर्वक जोड़ी गई",
        "Task_Type_already_exists": "कार्य प्रकार पहले से मौजूद है",
        "Task_Type_added_sucessfully": "कार्य प्रकार सफलतापूर्वक जोड़ा गया",
        "Image_size_must_be_less_than_ImageDimensions_pixels": "छवि का आकार ImageDimensions पिक्सल से कम होना चाहिए।",
        "Data_deleted_successfully": "डेटा सफलतापूर्वक हटाया गया।",
        "Category_created_successfully": "श्रेणी सफलतापूर्वक बनाई गई",
        "Please_select_an_image_file": "कृपया एक छवि फ़ाइल चुनें",
        "Channel_created_successfully": "चैनल सफलतापूर्वक बनाया गया",
        "Folder_not_found": "फ़ोल्डर नहीं मिला",
        "Template_&_Project_data_has_been_added_successfully": "टेम्पलेट और परियोजना डेटा सफलतापूर्वक जोड़ा गया।",
        "Project_data_has_been_added_successfully": "परियोजना डेटा सफलतापूर्वक जोड़ा गया {filterMessage}",
        "Error_in_creating_project": "परियोजना बनाने में त्रुटि",
        "Milestone_deleted_successfully": "मील का पत्थर सफलतापूर्वक हटा दिया गया",
        "Error_in_deleting_milestone": "मील का पत्थर हटाने में त्रुटि",
        "Milestone_added_successfully": "मील का पत्थर सफलतापूर्वक जोड़ा गया",
        "Error_in_adding_milestone": "मील का पत्थर जोड़ने में त्रुटि",
        "Milestone_update_successfully": "मील का पत्थर सफलतापूर्वक अपडेट किया गया",
        "Error_in_updating_milestone": "मील का पत्थर अपडेट करने में त्रुटि",
        "Milestone_status_update_successfully": "मील का पत्थर स्थिति सफलतापूर्वक अपडेट की गई",
        "Error_in_updating_milestone_status": "मील का पत्थर स्थिति अपडेट करने में त्रुटि",
        "Milestone_refund_amount_update_successfully": "मील का पत्थर रिफंड राशि सफलतापूर्वक अपडेट की गई",
        "Error_in_updating_milestone_refund_amount": "मील का पत्थर रिफंड राशि अपडेट करने में त्रुटि",
        "The_project_not_found": "परियोजना नहीं मिली",
        "The_project_is_archived": "परियोजना आर्काइव की गई है",
        "Start_date_of_project_should_be_smaller_than_current_date": "परियोजना की शुरुआत तिथि वर्तमान तिथि से छोटी होनी चाहिए",
        "All_the_range_is_included_in_milestone": "सभी श्रेणियां मील का पत्थर में शामिल हैं",
        "Please_enter_start_date_of_project": "कृपया परियोजना की शुरुआत तिथि दर्ज करें",
        "Project_name_updated_successfully": "परियोजना का नाम सफलतापूर्वक अपडेट किया गया",
        "Project restored successfully": "परियोजना सफलतापूर्वक पुनर्स्थापित की गई",
        "Project closed successfully": "परियोजना सफलतापूर्वक बंद की गई",
        "Project archived successfully": "परियोजना सफलतापूर्वक आर्काइव की गई",
        "Project deleted successfully": "परियोजना सफलतापूर्वक हटा दी गई",
        "Enter_valid_project_source": "कृपया वैध परियोजना स्रोत दर्ज करें",
        "Please_select_sub_task": "कृपया उपकार्य चुनें",
        "Status_not_updated": "स्थिति अपडेट नहीं हुई",
        "Start_date_updated_successfully": "शुरुआत तिथि सफलतापूर्वक अपडेट की गई",
        "Start_date_not_updated": "शुरुआत तिथि अपडेट नहीं हुई",
        "Task_converted_sucessfully": "कार्य सफलतापूर्वक रूपांतरित किया गया",
        "Task_merged_sucessfully": "कार्य सफलतापूर्वक मर्ज किया गया",
        "Can_not_create_template_name_Custom": "कस्टम नाम वाला टेम्पलेट नहीं बना सकते",
        "Template_name_updated_successfully": "टेम्पलेट नाम सफलतापूर्वक अपडेट किया गया",
        "Template_has_been_created_Successfully": "टेम्पलेट सफलतापूर्वक बनाया गया",
        "Template_deleted_successfull": "टेम्पलेट सफलतापूर्वक हटा दिया गया",
        "Template_has_been_deleted_successfully": "टेम्पलेट सफलतापूर्वक हटा दिया गया",
        "Storage_exceeded_Upgrade_your_plan": "स्टोरेज सीमा समाप्त हो गई है। अपनी योजना अपग्रेड करें",
        "max_filesize_messages": "अधिकतम फ़ाइल आकार FILE_SIZE MB है।",
        "Password_reset_email_has_been_sent_successfully": "पासवर्ड रीसेट ईमेल सफलतापूर्वक भेजा गया",
        "Invalid_username_or_password": "अमान्य उपयोगकर्ता नाम या पासवर्ड",
        "Email_Not_Verified": "ईमेल सत्यापित नहीं है",
        "Verification_mail_has_been_send_successfully": "सत्यापन मेल सफलतापूर्वक भेजा गया",
        "Invalid_url": "अमान्य यूआरएल",
        "User_already_registered": "उपयोगकर्ता पहले से पंजीकृत है",
        "User_has_been_registered_successfully": "उपयोगकर्ता सफलतापूर्वक पंजीकृत किया गया",
        "The_email_address_is_already_in_use": "ईमेल पता पहले से उपयोग में है",
        "User_has_been_registered_successfully_Please_verify_your_email_to_continue": "उपयोगकर्ता सफलतापूर्वक पंजीकृत किया गया है, कृपया जारी रखने के लिए अपना ईमेल सत्यापित करें",
        "Password_reset_has_been_successfully": "पासवर्ड रीसेट सफलतापूर्वक किया गया",
        "Your_email_has_been_verify_successfully": "आपका ईमेल सफलतापूर्वक सत्यापित किया गया",
        "Invitation_accepted_successfully": "निवेदन सफलतापूर्वक स्वीकार किया गया",
        "Only_product_owner_can_create_a_company": "केवल उत्पाद स्वामी ही कंपनी बना सकते हैं",
        "Company_name_must_be_unique": "कंपनी का नाम अद्वितीय होना चाहिए",
        "Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "सदस्यता सफलतापूर्वक रद्द कर दी गई। कृपया परिवर्तनों के प्रभावी होने के लिए 2 से 3 मिनट का समय दें।",
        "Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "सदस्यता सफलतापूर्वक पुनः सक्रिय कर दी गई। कृपया परिवर्तनों के प्रभावी होने के लिए 2 से 3 मिनट का समय दें।",
        "View_name_is_required": "दृश्य नाम आवश्यक है",
        "name_should_be_at_least_3_characters_long": "नाम कम से कम 3 अक्षरों का होना चाहिए",
        "View_name_already_exists": "दृश्य नाम पहले से मौजूद है",
        "View_added_successfully": "दृश्य सफलतापूर्वक जोड़ा गया",
        "View_Deleted_Successfully": "दृश्य सफलतापूर्वक हटा दिया गया",
        "Link_copied_to_clipboard_successfully": "लिंक सफलतापूर्वक क्लिपबोर्ड में कॉपी किया गया",
        "Project_avatar_updated_successfully": "परियोजना का अवतार सफलतापूर्वक अपडेट किया गया",
        "Message pinned successfully": "संदेश सफलतापूर्वक पिन किया गया",
        "Message unpinned successfully": "संदेश सफलतापूर्वक अनपिन किया गया",
        "Message_copied": "संदेश कॉपी किया गया",
        "Item_cannot_be_empty": "वस्तु खाली नहीं हो सकती",
        "Maximum_MAX_CHAR_characters_are_allowed": "अधिकतम MAX_CHAR अक्षर अनुमत हैं",
        "Item_added_to_checklist": "वस्तु चेकलिस्ट में जोड़ी गई",
        "Maximum_10_files_can_be_uploaded_at_once": "एक बार में अधिकतम 10 फ़ाइलें अपलोड की जा सकती हैं",
        "file_type_is_not_supported": "फ़ाइल प्रकार समर्थित नहीं है!",
        "ERROR_in_file_upload": "फ़ाइल अपलोड में त्रुटि",
        "file_size_is_larger_than_FILE_SIZE_mb": "फ़ाइल आकार FILE_SIZE एमबी से बड़ा है!",
        "Mark_as_favorite_successfully": "सफलतापूर्वक पसंदीदा के रूप में चिह्नित किया गया",
        "Start_and_Due_date_updated_successfully": "शुरुआत और नियत तारीख सफलतापूर्वक अपडेट की गई",
        "Start_and_Due_date_not_updated": "शुरुआत और नियत तारीख अपडेट नहीं की गई",
        "Attchments_deleted_successfully": "संलग्नक सफलतापूर्वक हटाए गए",
        "Designation_is_required": "पदनाम आवश्यक है",
        "Designation_already_exists": "पदनाम पहले से मौजूद है",
        "Designation_added_successfully": "पदनाम सफलतापूर्वक जोड़ा गया",
        "Designation_updated_successfully": "पदनाम सफलतापूर्वक अपडेट किया गया",
        "Role_is_required": "भूमिका आवश्यक है",
        "Role_already_exists": "भूमिका पहले से मौजूद है",
        "Role_added_successfully": "भूमिका सफलतापूर्वक जोड़ी गई",
        "Role_updated_successfully": "भूमिका सफलतापूर्वक अपडेट की गई",
        "Please_provide_an_email_id": "कृपया एक ईमेल आईडी प्रदान करें",
        "Please_provide_a_designation": "कृपया एक पदनाम प्रदान करें",
        "Please_provide_a_role": "कृपया एक भूमिका प्रदान करें",
        "Designation_deleted_successfully": "पदनाम सफलतापूर्वक हटाया गया",
        "The_role_is_already_in_use_so_it_can't_be_deleted": "भूमिका पहले से उपयोग में है, इसलिए इसे हटाया नहीं जा सकता",
        "Role_deleted_successfully": "भूमिका सफलतापूर्वक हटाई गई",
        "Language_not_updated": "भाषा अपडेट नहीं की गई!",
        "Profile_updated_successfully": "प्रोफ़ाइल सफलतापूर्वक अपडेट की गई",
        "Notification_Settings_Update_successfully": "सूचना सेटिंग्स सफलतापूर्वक अपडेट की गई",
        "Permission_updated_successfully": "अधिकार सफलतापूर्वक अपडेट किए गए",
        "Per_User_Generate_Limit_value_is_not_valid": "प्रति उपयोगकर्ता उत्पन्न सीमा मान अमान्य है",
        "Team_name_is_required": "टीम नाम आवश्यक है",
        "Minimum_3_character_required": "कम से कम 3 वर्ण आवश्यक हैं",
        "Team_name_already_exist": "टीम नाम पहले से मौजूद है",
        "Template_has_been_added_successfully": "टेम्पलेट सफलतापूर्वक जोड़ा गया",
        "Billing_details_has_been_updated_successfully": "बिलिंग विवरण सफलतापूर्वक अपडेट किए गए",
        "Billing_details_not_updated": "बिलिंग विवरण अपडेट नहीं किए गए",
        "Invalid_Card_Details_Please_check_and_try_again": "अमान्य कार्ड विवरण। कृपया जांचें और फिर से प्रयास करें",
        "Expired_Card_Please_check_and_try_again": "समाप्त कार्ड। कृपया जांचें और फिर से प्रयास करें",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again": "अमान्य कार्ड सत्यापन कोड (CVC)। कृपया जांचें और फिर से प्रयास करें",
        "You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again": "आपने अपनी वर्तमान सदस्यता समाप्ति अवधि के अंत में रद्द कर दी है, कृपया सदस्यता को पुनः सक्रिय करें और फिर से प्रयास करें",
        "Plan_not_purchased_Please_try_again": "योजना नहीं खरीदी गई। कृपया फिर से प्रयास करें",
        "Please_fill_out_billing_details_first": "कृपया पहले बिलिंग विवरण भरें",
        "Please_check_your_credential": "कृपया अपनी क्रेडेंशियल्स जांचें",
        "File_type_not_supported": "फ़ाइल प्रकार समर्थित नहीं है",
        "Are_you_sure_to_delete_this_file": "क्या आप सुनिश्चित हैं कि आप इस फ़ाइल को हटाना चाहते हैं?",
        "Select_Project_Type": "परियोजना प्रकार चुनें",
        "Tracker_user_added_successfully": "ट्रैकर उपयोगकर्ता सफलतापूर्वक जोड़ा गया",
        "Tracker_user_removed_successfully": "ट्रैकर उपयोगकर्ता सफलतापूर्वक हटा दिया गया",
        "queue_list_not_updated": "क्यू सूची अपडेट नहीं हुई",
        "upgrade_plan_folder_limit_reached": "अपनी योजना अपग्रेड करें। आप फ़ोल्डर बनाने की सीमा तक पहुँच चुके हैं",
        "View_updated_successfully": "दृश्य सफलतापूर्वक अपडेट किया गया",
        "The_designation_is_already_in_use_so_it_cant_be_deleted": "पदनाम पहले से उपयोग में है, इसलिए इसे हटाया नहीं जा सकता",
        "Sprint_already_exists": "स्प्रिंट पहले से मौजूद है",
        "Folder_already_exists": "फ़ोल्डर पहले से मौजूद है",
        "Sprint updated successfully": "स्प्रिंट सफलतापूर्वक अपडेट किया गया",
        "Project_milestone_status_updated_successfully": "परियोजना मील का पत्थर स्थिति सफलतापूर्वक अपडेट किया गया।",
        "Invalid_email": "आपका ईमेल अमान्य है. कृपया जाँच करें और पुनः प्रयास करें",
        "Invalid_password": "तुम्हारा पासवर्ड अमान्य है। कृपया जाँच करें और पुनः प्रयास करें",
        "Too_many_request": "बहुत सारे अनुरोध. कृपया बाद में पुन: प्रयास करें",
        "Password_reset_link": "पासवर्ड समाप्ति ईमेल सफलतापूर्वक भेजा गया! कृपया अपना इनबॉक्स जांचें और अपना पासवर्ड रीसेट करने के लिए आगे बढ़ें।",
        "Project_milestone_status_added_successfully": "प्रोजेक्ट माइलस्टोन स्थिति सफलतापूर्वक जोड़ी गई.",
        "Please_select_start_end_date": "कृपया प्रारंभ और समाप्ति तिथि दोनों चुनें",
        "Invitation_canceled": "निमंत्रण रद्द किया गया: आप अब इस लिंक का उपयोग नहीं कर सकते",
        "Ai_limit_reached": "आपकी दैनिक सीमा पूरी हो गई है।",
        "You_have_reached_the_maximum_limit_of_guest_users": "अपनी योजना अपग्रेड करें। आप अतिथि उपयोगकर्ताओं की अधिकतम सीमा तक पहुँच चुके हैं।",
        "Upgrade_for_import": "आयात सुविधा का उपयोग करने के लिए अपनी योजना अपग्रेड करें।",
        "Upgrade_for_export": "निर्यात सुविधा का उपयोग करने के लिए अपनी योजना अपग्रेड करें।",
        "import_task_success": "आपके कार्य सफलतापूर्वक आयात कर लिए गए हैं।",
        "export_task_success": "कार्य सफलतापूर्वक निर्यात किए गए।",
        "export_task_error": "निर्यात करने के लिए कोई कार्य नहीं है।",
        "invalid_file_error": "अमान्य फ़ाइल प्रकार। कृपया एक .csv फ़ाइल अपलोड करें।",
        "free_company_limit_reached": "आप मुफ्त कंपनियों के निर्माण की अधिकतम सीमा तक पहुँच गए हैं।",
        "Import_users_successfully": "उपयोगकर्ता सफलतापूर्वक आयात किए गए",
        "date_range": "कृपया लागू करने से पहले एक दिनांक सीमा चुनें।",
        "Task_total_estimate_update_succesfull": "कार्य का कुल अनुमान सफलतापूर्वक अपडेट किया गया"
    },
    "SecurityAndPermission": {
        "project": "परियोजना",
        "project_list": "परियोजना सूची",
        "project_create": "परियोजना निर्माण",
        "project_name_edit": "परियोजना नाम संपादन",
        "project_sprint_create": "परियोजना स्प्रिंट निर्माण",
        "project_folder_create": "परियोजना फ़ोल्डर निर्माण",
        "project_folder_name_edit": "परियोजना फ़ोल्डर नाम संपादन",
        "project_sprint_name_edit": "परियोजना स्प्रिंट नाम संपादन",
        "project_details": "परियोजना विवरण",
        "project_status_change": "परियोजना स्थिति परिवर्तन",
        "project_assignee": "परियोजना असाइन किया गया व्यक्ति",
        "project_category": "परियोजना श्रेणी",
        "project_source": "परियोजना स्रोत",
        "project_type": "परियोजना प्रकार",
        "project_currency": "परियोजना मुद्रा",
        "project_amount": "परियोजना राशि",
        "project_start_date": "परियोजना आरंभ तिथि",
        "project_end_date": "परियोजना समाप्ति तिथि",
        "project_due_date": "परियोजना नियत तिथि",
        "project_close": "परियोजना बंद करें",
        "project_description": "परियोजना विवरण",
        "project_checklist": "परियोजना चेकलिस्ट",
        "project_checklist_assign_remove": "परियोजना चेकलिस्ट असाइन/हटाएं",
        "project_attachments": "परियोजना संलग्नक",
        "project_milestone": "परियोजना मील का पत्थर",
        "task": "कार्य",
        "task_list": "कार्य सूची",
        "task_create": "कार्य निर्माण",
        "sub_task_create": "उप कार्य निर्माण",
        "task_name_edit": "कार्य नाम संपादन",
        "task_status": "कार्य स्थिति",
        "task_assignee": "कार्य असाइन किया गया व्यक्ति",
        "task_priority": "कार्य प्राथमिकता",
        "task_due_date": "कार्य नियत तिथि",
        "task_estimated_hours": "कार्य अनुमानित घंटे",
        "task_description": "कार्य विवरण",
        "task_checklist": "कार्य चेकलिस्ट",
        "task_checklist_assign_remove": "कार्य चेकलिस्ट असाइन/हटाएं",
        "task_attachments": "कार्य संलग्नक",
        "show_tasks": "कार्य दिखाएं",
        "task_custom_field": "कस्टम फ़ील्ड",
        "settings": "कंपनी सेटिंग्स",
        "settings_edit_company": "कंपनी संपादित करें",
        "settings_task_priority": "कार्य प्राथमिकता",
        "settings_file_extensions": "फ़ाइल एक्सटेंशन",
        "settings_project_milestone_status": "परियोजना मील का पत्थर स्थिति",
        "settings_invite_member": "सदस्य आमंत्रित करें",
        "settings_member_list": "सदस्य सूची",
        "settings_create_team": "टीम निर्माण",
        "settings_team_list": "टीम सूची",
        "settings_project_list": "परियोजना सूची",
        "settings_security_permissions": "सुरक्षा और अनुमतियां",
        "settings_role_management": "भूमिका प्रबंधन",
        "settings_designation": "पदनाम",
        "milestone_weekly_range": "मील का पत्थर साप्ताहिक सीमा",
        "settings_custom_field": "कस्टम फ़ील्ड",
        "sheet_settings": "शीट सेटिंग्स",
        "user_timesheet": "उपयोगकर्ता टाइमशीट",
        "project_timesheet": "परियोजना टाइमशीट",
        "workload_timesheet": "वर्कलोड टाइमशीट",
        "milestone_report": "मील का पत्थर रिपोर्ट",
        "artificial_intelligence": "कृत्रिम बुद्धिमत्ता",
        "per_user_generate_limit": "प्रति उपयोगकर्ता टोकन सीमा",
        "project_custom_field": "परियोजना कस्टम फ़ील्ड",
        "public_projects": "सार्वजनिक परियोजना सूची",
        "tracker_timesheet": "ट्रैकर टाइमशीट",
        "view_list": "सूची देखें",
        "chat": "चैट",
        "project_delete": "प्रोजेक्ट हटाएं",
        "folder_archive": "फ़ोल्डर संग्रहित करें",
        "folder_delete": "फ़ोल्डर हटाएं",
        "folder_restore": "फ़ोल्डर पुनर्स्थापित करें",
        "sprint_type_change": "स्प्रिंट प्रकार परिवर्तन",
        "sprint_restore": "स्प्रिंट पुनर्स्थापित करें",
        "sprint_delete": "स्प्रिंट हटाएं",
        "sprint_archive": "स्प्रिंट संग्रहित करें",
        "chat_channel": "चैट चैनल बनाएँ",
        "chat_category": "चैट श्रेणी बनाएँ",
        "one_to_one_chat": "वन टू वन चैट",
        "task_tag": "कार्य टैग",
        "task_start_date": "कार्य प्रारंभ तिथि",
        "task_activity_log": "कार्य गतिविधि लॉग",
        "task_convert_to_list": "कार्य को सूची में बदलें",
        "task_convert_to_subtask": "कार्य को उपकार्य में बदलें",
        "task_duplicate": "कार्य डुप्लिकेट",
        "task_merge": "कार्य विलय",
        "task_move": "कार्य स्थानांतरित करें",
        "task_archive": "कार्य संग्रहित करें",
        "task_delete": "कार्य हटाएं",
        "task_comment": "कार्य टिप्पणी",
        "task_details": "कार्य विवरण",
        "queue_list": "प्रतीक्षा सूची",
        "advance_search": "उन्नत खोज",
        "list_view_column": "सूची दृश्य स्तंभ",
        "task_type": "कार्य प्रकार",
        "import_tasks": "कार्य आयात करें",
        "export_tasks": "कार्य निर्यात करें",
        "convert_to_task": "कार्य में परिवर्तित करें"
    },
    "general": {
        "Continue": "जारी रखें",
        "New_Status": "नया स्थिति",
        "Old_Status": "पुरानी स्थिति",
        "Old_Task_Type": "पुराना कार्य प्रकार",
        "New_Task_Type": "नया कार्य प्रकार",
        "New_Task_Assignee": "नया कार्य असाइन किया गया व्यक्ति",
        "Old_Task_Assignee": "पुराना कार्य असाइन किया गया व्यक्ति",
        "New_Task_Watchers": "नए कार्य देखने वाले",
        "Old_Task_Watchers": "पुराने कार्य देखने वाले",
        "Select_Status": "स्थिति चयनित करें",
        "Select_Task_Type": "कार्य प्रकार चयनित करें",
        "No_Assignee": "कोई असाइन किया गया व्यक्ति नहीं",
        "No_Watchers": "कोई देखने वाले नहीं",
        "Different_Statuses": "विभिन्न स्थिति",
        "Please_Select_Status": "कृपया स्थिति चयनित करें",
        "Tomorrow": "कल",
        "Yesterday": "कल",
        "Project": "परियोजना",
        "Team": "टीम",
        "User": "उपयोगकर्ता",
        "Copy_Assignees": "असाइन किए गए व्यक्तियों की नकल करें",
        "Copy_Watchers": "देखने वालों की नकल करें",
        "apply": "लागू करें",
        "current_month": "वर्तमान माह",
        "current_week": "वर्तमान सप्ताह",
        "keyboard": "कीबोर्ड",
        "mouse": "माउस",
        "Create": "बनाएं",
        "scroll_to_bottom": "नीचे स्क्रॉल करें",
        "unassigned": "असाइन नहीं किया गया",
        "entries": "एंट्रीज़",
        "showing": "दिखा रहे हैं",
        "page_not_found": "उफ़, पृष्ठ नहीं मिला",
        "page_not_found_description": "हमें इस असुविधा के लिए खेद है। ऐसा लगता है कि आप एक पृष्ठ तक पहुंचने की कोशिश कर रहे हैं जो या तो हटा दिया गया है या कभी अस्तित्व में नहीं था।",
        "note": "नोट",
        "settings_change_no_effect": "नीचे दिए गए सेटिंग्स में परिवर्तन मौजूदा फ़ील्ड मानों को प्रभावित नहीं करेंगे यदि वे खाली नहीं हैं",
        "advanced": "उन्नत",
        "general": "सामान्य",
        "limits": "सीमाएँ",
        "message_deleted": "संदेश हटाया गया",
        "company_individual": "कंपनी/व्यक्ति का नाम",
        "enter_company_individual": "कंपनी/व्यक्ति का नाम दर्ज करें"
    },
    "monthName": {
        "jan": "जनवरी",
        "feb": "फरवरी",
        "mar": "मार्च",
        "apr": "अप्रैल",
        "may": "मई",
        "jun": "जून",
        "jul": "जुलाई",
        "aug": "अगस्त",
        "sep": "सितंबर",
        "oct": "अक्टूबर",
        "nov": "नवंबर",
        "dec": "दिसंबर"
    },
    "timeLog": {
        "start_time_field_required": "स्टार्ट टाइम फ़ील्ड आवश्यक है",
        "end_time_field_required": "एंड टाइम फ़ील्ड आवश्यक है",
        "select_valid_time_duration": "कृपया मान्य समय अवधि चुनें"
    },
    "weekName": {
        "sun": "रवि",
        "mon": "सोम",
        "tue": "मंगल",
        "wed": "बुध",
        "thu": "गुरु",
        "fri": "शुक्र",
        "sat": "शनि",
        "fridays": "शुक्रवार",
        "mondays": "सोमवार",
        "saturdays": "शनिवार",
        "sundays": "रविवार",
        "thursdays": "गुरुवार",
        "tuesdays": "मंगलवार",
        "wednesdays": "बुधवार"
    },
    "tooltipText": {
        "enable_app_manage_priority": "इस ऐप को सक्षम करने से आप इस <b>परियोजना</b> के <b>कार्य</b> में <b>प्राथमिकता</b> प्रबंधित कर सकेंगे।",
        "enable_app_manage_multiple_assignee": "इस ऐप को सक्षम करने से आप इस <b>परियोजना</b> के <b>कार्य</b> में <b>एकाधिक असाइन किए गए व्यक्तियों</b> को प्रबंधित कर सकेंगे।",
        "enable_app_manage_time_estimates": "इस ऐप को सक्षम करने से आप इस <b>परियोजना</b> के <b>कार्य</b> में <b>समय अनुमान</b> प्रबंधित कर सकेंगे।",
        "enable_app_manage_tags": "इस ऐप को सक्षम करने से आप इस <b>परियोजना</b> के <b>कार्य</b> में <b>टैग</b> प्रबंधित कर सकेंगे।",
        "enable_app_use_milestones": "इस ऐप को सक्षम करने से आप इस <b>परियोजना</b> के लिए <b>मील के पत्थर</b> का उपयोग कर सकेंगे।",
        "enable_app_use_ai_operations": "इस ऐप को सक्षम करने से आप इस <b>परियोजना</b> के लिए <b>एआई संचालन</b> का उपयोग कर सकेंगे।",
        "enable_app_manage_time_log": "इस ऐप को सक्षम करने से आप इस <b>परियोजना</b> के <b>कार्य</b> में <b>समय लॉग</b> प्रबंधित कर सकेंगे।",
        "enable_app_manage_custom_fields": "इस ऐप को सक्षम करने से आप इस <b>परियोजना</b> के लिए <b>कस्टम फ़ील्ड्स</b> प्रबंधित कर सकेंगे।"
    },
    "Company": {
        "fill_company_details": "कृपया अपनी कंपनी के विवरण भरें",
        "set_up_company": "अपनी कंपनी सेटअप करें",
        "creating_company": "कंपनी बनाई जा रही है",
        "company_created": "आपकी कंपनी बन गई है। हमने प्रारंभिक कदम सेट कर दिए हैं। कृपया कुछ क्षण प्रतीक्षा करें।",
        "good_to_go": "शुरू करने के लिए तैयार",
        "select_default_country": "डिफ़ॉल्ट देश चयनित करें",
        "freelimitreachedstart": "आप पहले ही एक मुफ्त कंपनी बना चुके हैं। नई कंपनी बनाने के लिए, आपको पहले एक सशुल्क योजना में अपग्रेड करना होगा।",
        "freelimitreachedend": "एक बार अपग्रेड करने के बाद, आप एक और मुफ्त कंपनी जोड़ने के लिए तैयार होंगे।"
    },
    "Subscription": {
        "subscription_cancelled": "आपने अपने वर्तमान सब्सक्रिप्शन अवधि के अंत में अपनी सदस्यता रद्द कर दी है",
        "discard_changes": "यदि आप इसे अपनी सदस्यता में जोड़ते हैं, तो इन परिवर्तनों को रद्द कर दिया जाएगा, और आपकी वर्तमान सदस्यता अगले बिलिंग चक्र से जारी रहेगी।",
        "confirm_terminate_schedule": "क्या आप सुनिश्चित हैं कि आप सदस्यता रद्दीकरण अनुसूची को समाप्त करना चाहते हैं?",
        "confirm_add_user": "क्या आप सुनिश्चित हैं कि आप अपनी सदस्यता में उपयोगकर्ता जोड़ना चाहते हैं?",
        "confirm_remove_user": "क्या आप सुनिश्चित हैं कि आप सदस्यता से उपयोगकर्ता को हटाना चाहते हैं?",
        "next_invoice_amount": "आपका अगला बिल इस राशि का होगा",
        "credits_applied": "क्रेडिट लागू किया गया",
        "current_billing_for_upgrade": "अपग्रेड के लिए वर्तमान बिलिंग",
        "plan_upgrade_success": "बधाई हो! आपकी योजना का अपग्रेड सफलतापूर्वक अनुसूचित किया गया है, और सुधार वर्तमान अवधि के अंत के बाद प्रभावी होंगे। अगले चरण में अपग्रेडेड सुविधाओं और लाभों का अनुभव करने के लिए तैयार रहें।",
        "subscription_upgrade_from": "आपकी सदस्यता इस तिथि से अपग्रेड होगी",
        "total_payable_amount": "कुल भुगतान योग्य राशि",
        "update_subscription": "सदस्यता अपडेट करें",
        "updated_subscription_price": "अपडेटेड सदस्यता मूल्य",
        "upgrade_subscription": "सदस्यता अपग्रेड करें",
        "confirm_subscription_change": "क्या आप सुनिश्चित हैं कि आप अपनी सदस्यता को बदलना चाहते हैं",
        "monthly": "माह",
        "yearly": "वर्ष",
        "remove_scheduled_cancellation_confirmation": "'हां' पर क्लिक करने से निर्धारित रद्दीकरण हटा दिया जाएगा और आपका बिलिंग चक्र जारी रहेगा।",
        "scheduled_cancellation_notice": "आपकी वर्तमान सदस्यता का निर्धारित रद्दीकरण है",
        "credit_entitlement_congratulations": "बधाई हो! आप को एक क्रेडिट का हकदार है",
        "credit_note_application": "आपकी वर्तमान सदस्यता के लिए। यह क्रेडिट नोट आसानी से आपकी सदस्यता में सुधार के लिए लागू किया जाएगा, और यह आपके आगामी बिलों से स्वचालित रूप से कट जाएगा, जो आपकी सदस्यता यात्रा के लिए निरंतर मूल्य और बचत सुनिश्चित करेगा।",
        "invoice_period_coverage": "चरण अवधि से संबंधित इनवॉइस अवधि"
    },
    "Card": {
        "pay_with": "इसके साथ भुगतान करें",
        "add_new_card": "नया कार्ड जोड़ें",
        "name_on_card": "कार्ड पर नाम",
        "card_number": "कार्ड संख्या",
        "expiry": "समाप्ति",
        "cvc": "CVC"
    },
    "alertBox": {
        "updateBillingAddress": "आपको पहला बिलिंग पता अपडेट करना होगा",
        "valid_csv_title": "कोई फ़ाइल अपलोड नहीं की गई",
        "valid_csv_text": "कृपया आगे बढ़ने के लिए एक मान्य .csv फ़ाइल अपलोड करें।",
        "ok": "ठीक है",
        "cancel": "रद्द करें",
        "go_back_title": "पीछे जाएँ?",
        "go_back_text": "क्या आप वास्तव में पिछले चरण पर वापस जाना चाहते हैं?",
        "close_modal_title": "मॉडल बंद करें?",
        "close_modal_text": "क्या आप वास्तव में मॉडल बंद करना चाहते हैं? इस चरण तक की सारी जानकारी खो जाएगी।",
        "no": "नहीं",
        "yes": "हाँ",
        "confirm": "पुष्टि करें",
        "improper_header_selection_title": "अमान्य चयन",
        "improper_header_selection_text": "चयनित पंक्ति में गैर-स्ट्रिंग मान हैं। कृपया एक अलग पंक्ति चुनें।",
        "missing_fields_title": "अनिवार्य फ़ील्ड गुम हैं",
        "missing_fields_text": "आगे बढ़ने से पहले कृपया नीचे दी गई आवश्यक फ़ील्ड्स को मैप करें और पुष्टि करें।",
        "warning_title": "चेतावनी",
        "warning_text": "जब आप आगे बढ़ेंगे, तो 'टास्क प्राथमिकता' और 'स्थिति' में रिक्त मान क्रमशः 'मध्यम' और 'करना है' के रूप में ले लिए जाएंगे।",
        "incomplete_mapping_title": "अपूर्ण मैपिंग",
        "incomplete_mapping_text": "आगे बढ़ने के लिए कृपया सभी अद्वितीय मानों को कम से कम एक Hyphen OI Pro मान के साथ मैप करें।",
        "invalid_tasks_error": "कोई मान्य कार्य नहीं मिला। कृपया सुनिश्चित करें कि आवश्यक फ़ील्ड खाली नहीं हैं।"
    },
    "importTaskButton": {
        "import_title": "कार्य आयात करें",
        "import_button": "CSV से टास्क आयात करें",
        "back_button": "पीछे जाएँ",
        "next_button": "आगे बढ़ें",
        "export_button": "CSV के रूप में निर्यात करें",
        "import_processing": "आपके कार्य आयात किए जा रहे हैं।"
    },
    "importCsvAndSetHeader": {
        "download": "डाउनलोड",
        "demo_csv": "डेमो CSV",
        "down_demo_text": "फ़ाइल की तुलना अपनी आयात फ़ाइल से करें ताकि यह सुनिश्चित किया जा सके कि आपकी फ़ाइल सही प्रारूप में है।",
        "upload_button": "अपनी CSV फ़ाइल यहाँ अपलोड करें",
        "upload_instructions": "आप किसी भी .csv फ़ाइल को अपलोड कर सकते हैं जिसमें कोई भी कॉलम हो, जहाँ प्रत्येक पंक्ति एक रिकॉर्ड दर्शाती हो। अगले चरण में, आपको अपने स्प्रेडशीट कॉलम्स को सही डेटा पॉइंट्स के साथ मैप करने की अनुमति दी जाएगी। अंतिम रिपोर्ट से पहले आप गलत डेटा को हटा या संपादित भी कर सकते हैं।",
        "header_row_question": "क्या चयनित पंक्ति में कॉलम हेडर हैं?",
        "select_another_button": "दूसरी पंक्ति चुनें",
        "confirm_row_btt": "पुष्टि करें"
    },
    "headerMapping": {
        "title": "हेडर मैपिंग",
        "mapping_instructions": "आइए, आपके हेडर्स को Hyphen OI Pro हेडर्स के साथ मैप करें",
        "pending_count": "शेष फ़ील्ड्स:",
        "confirmed_count": "पुष्ट फ़ील्ड्स:",
        "ignored_count": "अनदेखी की गई फ़ील्ड्स:",
        "custom_count": "कस्टम फ़ील्ड्स:",
        "confirmed_text": "पुष्ट",
        "ignored_text": "अनदेखी",
        "edit_button": "संपादित करें",
        "no_match_title": "कोई मेल नहीं",
        "no_match": "कोई मेल नहीं मिला",
        "no_match_description": "यह फ़ील्ड हमारे हेडर्स से मेल नहीं खाती। कृपया इसे अनदेखा करें या कस्टम फ़ील्ड के रूप में शामिल करें।",
        "custom_field_button": "कस्टम फ़ील्ड के रूप में जोड़ें",
        "ignore_field_button": "इस फ़ील्ड को अनदेखा करें",
        "matched_to_field": "मेल खाती फ़ील्ड:",
        "duplication_warning": "यह फ़ील्ड डुप्लिकेट है और इसे पुष्टि नहीं किया जा सकता। कृपया दूसरी फ़ील्ड चुनें।",
        "confirm_map_button": "मैपिंग की पुष्टि करें"
    },
    "reviewMaping": {
        "title": "कृपया हमारी फ़ील्ड्स में मैप किए गए अपने डेटा की समीक्षा करें। (आप यहाँ डेटा मानों को संपादित भी कर सकते हैं।)",
        "warning": "आपकी एक या अधिक आवश्यक फ़ील्ड्स गायब हैं या उनमें अमान्य मान हैं। कृपया इन्हें ठीक करें, अन्यथा ये पंक्तियाँ आयात नहीं की जाएँगी।"
    },
    "valueMapping": {
        "user_mapping_title": "उपयोगकर्ता मैपिंग",
        "user_mapping_instruction": "असाइनमेंट, लीड और टास्क गतिविधियों को बनाए रखने के लिए Hyphen OI Pro उपयोगकर्ताओं के साथ उपयोगकर्ताओं को मैप करें। यदि आप उपयोगकर्ताओं को मैप नहीं करते हैं, तो डेटा अभी भी आयात नहीं होगा क्योंकि यह Hyphen OI Pro उपयोगकर्ताओं से मेल नहीं खा सकेगा।",
        "user_dropdown_text": "उपयोगकर्ता चुनें",
        "status_mapping_title": "स्थिति मैपिंग",
        "status_mapping_instruction": "भविष्य की वर्कफ़्लो संगति सुनिश्चित करने के लिए, कृपया अपनी स्थिति मानों को Hyphen OI Pro में मौजूदा मानों के साथ मैप करें। इससे किसी भी गलती से बचने में मदद मिलेगी।",
        "status_dropdown_text": "स्थिति चुनें",
        "priority_mapping_title": "प्राथमिकता मैपिंग",
        "priority_mapping_instruction": "भविष्य की वर्कफ़्लो संगति सुनिश्चित करने के लिए, कृपया अपनी प्राथमिकता मानों को Hyphen OI Pro में मौजूदा मानों के साथ मैप करें। इससे गलतियों को रोका जा सकेगा।",
        "priority_dropdown_text": "प्राथमिकता चुनें",
        "custom_field_mapping_title": "कस्टम फ़ील्ड मैपिंग",
        "custom_field_mapping_instruction": "संगति सुनिश्चित करने के लिए, कृपया अपनी कस्टम फ़ील्ड प्रकारों को Hyphen OI Pro में मौजूदा प्रकारों के साथ मैप करें। इससे गलतियों से बचा जा सकेगा।",
        "custom_delimiters_quest": "ℹ️ क्या आपकी कस्टम फ़ील्ड मानों को अलग करने के लिए कोई डिलीमीटर है?"
    },
    "importMappingKeywords": {
        "task_id_description": "विशिष्ट कार्य का आईडी।",
        "task_name_description": "कार्य का नाम, आमतौर पर एक संक्षिप्त सारांश।",
        "task_description_description": "कार्य की विस्तृत जानकारी।",
        "task_assignee_description": "कार्य के लिए असाइन किए गए व्यक्ति का ईमेल पता।",
        "task_parentId_description": "इस कार्य से संबंधित माता-पिता कार्य का आईडी।",
        "task_leaderId_description": "इस कार्य का नेतृत्व करने वाले व्यक्ति का उपयोगकर्ता आईडी।",
        "task_priority_description": "कार्य को दी गई महत्वता का स्तर।",
        "task_status_description": "कार्य की वर्तमान स्थिति या प्रगति।",
        "task_start_date_description": "कार्य प्रारंभ होने की तारीख।",
        "task_due_date_description": "कार्य पूरा करने की अंतिम तिथि।"
    },
    "Affiliate": {
        "refer_earn": "रेफर करें और कमाएं",
        "unlimited": "असीमित",
        "invite_start_earning_cash_rewards": "अपने दोस्तों को आमंत्रित करें और नकद पुरस्कार कमाना शुरू करें।",
        "your_referral_code": "आपका रेफरल कोड",
        "invite_spend_message": "आपके दोस्त की हर खर्च पर, आपको उस राशि का {percentage}% पुरस्कार मिलेगा।",
        "inviteText": "इस लिंक को साझा करके दोस्तों को आमंत्रित करें",
        "copy": "कॉपी",
        "refferal_code_label": "रेफरल कोड",
        "refferal_code_placeholder": "रेफरल कोड दर्ज करें",
        "invalid_refferal_model_title": "आपका रेफरल कोड अमान्य है",
        "invalid_refferal_model_confirm_text": "हाँ, इसे बनाएँ!",
        "invalid_refferal_model_text": "क्या आप वाकई कंपनी बनाना चाहते हैं?",
        "refferal_code_error": "रेफरल कोड मान्य नहीं है"
    },
    "dashboardCard": {
        "tasks_by_assignee_bar_chart_description": "अपने कुल कार्यों को असाइन किए गए व्यक्ति के अनुसार बार ग्राफ़ में प्रदर्शित करें",
        "tasks_by_assignee_bar_chart_title": "असाइन किए गए व्यक्ति के अनुसार कार्य",
        "task_list_description": "किसी भी स्थान से कार्यों का सूची दृश्य बनाएं",
        "tasks_list_title": "कार्य सूची",
        "tasks_by_assignee_stack_bar_chart_description": "अपने कुल कार्यों को असाइन किए गए व्यक्ति के अनुसार स्टैक बार ग्राफ़ में प्रदर्शित करें",
        "tasks_by_assignee_stack_bar_chart_title": "असाइन किए गए व्यक्ति के अनुसार कार्य",
        "workload_by_status_stack_bar_chart_description": "विभिन्न स्थानों में आपकी स्थिति का विस्तृत विश्लेषण दिखाएं",
        "workload_by_status_stack_bar_chart_title": "स्थिति के अनुसार कार्यभार",
        "tasks_by_assignee_pie_chart_description": "अपने कुल कार्यों को असाइन किए गए व्यक्ति के अनुसार पाई चार्ट में प्रदर्शित करें",
        "tasks_by_assignee_pie_chart_title": "असाइन किए गए व्यक्ति के अनुसार कार्य",
        "workload_by_status_pie_chart_description": "विभिन्न स्थानों में आपकी स्थिति के उपयोग का पाई चार्ट प्रदर्शित करें",
        "workload_by_status_pie_chart_title": "स्थिति के अनुसार कार्यभार",
        "workload_by_status_bar_chart_description": "विभिन्न स्थानों में आपकी स्थिति के उपयोग का बार चार्ट प्रदर्शित करें",
        "workload_by_status_bar_chart_title": "स्थिति के अनुसार कार्यभार",
        "queue_list_title": "कतार सूची",
        "queue_list_description": "अपनी कार्य सूची और उनकी स्थिति देखें।",
        "card_name": "कार्ड का नाम",
        "location": "परियोजना",
        "group_by": "समूहबद्ध करें",
        "show_assignees": "असाइन किए गए व्यक्ति दिखाएं",
        "include_subtasks": "उप-कार्य शामिल करें",
        "display_labels_as_percent": "लेबल को प्रतिशत के रूप में प्रदर्शित करें",
        "show_legend": "लीजेंड दिखाएं",
        "show_Data_Labels": "डेटा लेबल दिखाएं",
        "select": "चयन करें",
        "add_card": "कार्ड जोड़ें",
        "back": "वापस",
        "error_assignees": "असाइन किए गए व्यक्ति दिखाने वाला फ़ील्ड आवश्यक है",
        "error_location": "स्थान फ़ील्ड आवश्यक है",
        "empty_layout_container": "आपका डैशबोर्ड खाली है। शुरू करने के लिए 'कार्ड जोड़ें' पर क्लिक करें।",
        "status": "स्थिति",
        "edit_card": "कार्ड संपादित करें",
        "calendar_card_title": "कैलेंडर",
        "calendar_card_description": "यह कार्यों के लिए कैलेंडर दृश्य है",
        "measure": "माप",
        "calculation": "गणना",
        "total_urgent_tasks": "कुल तात्कालिक कार्य",
        "total_urgent_tasks_description": "स्थान के अनुसार कुल तात्कालिक कार्यों की संख्या प्रदर्शित करें",
        "time_tracker": "समय ट्रैकर",
        "time_estimate": "समय अनुमान",
        "range": "सीमा",
        "max": "अधिकतम",
        "min": "न्यूनतम",
        "median": "मध्यिका",
        "average": "औसत",
        "sum": "योग",
        "workload_estination_title": "समय रिपोर्टिंग",
        "workload_estination_description": "ऐसे कार्य देखें जिनमें समय ट्रैक और अनुमानित किया गया हो।",
        "workload_only_estination_title": "अनुमानित समय",
        "workload_only_estination_description": "अनुमानित समय देखें।",
        "time_only_estination_title": "लॉग किया गया समय",
        "time_only_estination_description": "लॉग किया गया समय देखें।",
        "today": "आज",
        "yesterday": "कल",
        "this_week": "इस सप्ताह",
        "last_week": "पिछला सप्ताह",
        "this_month": "इस महीने",
        "last_month": "पिछला महीना",
        "this_year": "इस साल",
        "last_30_days": "पिछले 30 दिन",
        "task": "कार्य गणना",
        "task_label": "कार्य लेबल",
        "both": "दोनों दिखाएं",
        "manual_time": "केवल मैन्युअल समय दिखाएं",
        "track_time": "केवल ट्रैक किया गया समय दिखाएं",
        "logtype": "समय लॉग",
        "timerange": "समय अवधि",
        "priority": "प्राथमिकता",
        "due_date": "नियत तिथि",
        "none": "कोई नहीं",
        "total_time_track_description": "कुल समय ट्रैक दिखाएं",
        "total_time_track_tasks": "कुल समय ट्रैक",
        "total_tasks_count_description": "कुल कार्यों की संख्या दिखाएं",
        "total_tasks_count": "कुल कार्यों की संख्या",
        "assignees": "कार्य असाइन किए गए लोग",
        "feature": "फ़ीचर",
        "workload": "कार्यभार",
        "time_tracking": "समय ट्रैकिंग",
        "task_card": "कार्यों",
        "Today": "आज",
        "Yesterday": "कल",
        "Tomorrow": "आने वाला कल",
        "This_week": "इस सप्ताह",
        "Next_week": "अगला सप्ताह",
        "Next_seven_days": "अगले सात दिन",
        "Last_seven_days": "पिछले सात दिन",
        "Last_month": "पिछला महीना",
        "This_month": "इस महीने",
        "Next_month": "अगला महीना",
        "Date_range": "तारीख सीमा",
        "me_mode": "मैं",
        "data": "डेटा",
        "display": "प्रदर्शन",
        "fields": "फ़ील्ड्स"
    },
    "designationMapping": {
        "title": "पदनाम मानचित्रण",
        "description": "कृपया अपने CSV में दिए गए पदनामों को Hyphen OI Pro में मौजूदा पदनामों से मिलाएँ।"
    },
    "roleMapping": {
        "title": "भूमिका मानचित्रण",
        "description": "कृपया अपने CSV में दी गई भूमिकाओं को Hyphen OI Pro में मौजूदा भूमिकाओं से मिलाएँ।"
    },
    "importUserKeywords": {
        "user_email_description": "उपयोगकर्ता का ईमेल आईडी",
        "user_role_description": "संगठन के भीतर उपयोगकर्ता को सौंपी गई भूमिका या नौकरी का शीर्षक।",
        "user_designation_description": "कंपनी में कर्मचारी का आधिकारिक पदनाम या नौकरी का शीर्षक।"
    },
    "userSelection": {
        "title": "उपयोगकर्ता चयन",
        "user_limit_error": "अधिकतम उपयोगकर्ता सीमा पहुँच चुकी है। अधिक उपयोगकर्ताओं को आयात करने के लिए कृपया अपनी योजना अपडेट करें।",
        "description": "सभी उपयोगकर्ताओं का चयन करें जिन्हें आप आयात करना चाहते हैं।",
        "duplicate_email_error": "यह ईमेल आईडी पहले से ही Hyphen OI Pro में मौजूद है। आप इसे आयात नहीं कर सकते।",
        "invalid_email": "यह ईमेल आईडी अमान्य है। कृपया एक मान्य ईमेल आईडी का उपयोग करें।",
        "invalid_fields": "आपके पास एक या अधिक अमान्य फ़ील्ड हैं। कृपया हाइलाइट किए गए फ़ील्ड की जांच करें।",
        "user_limit_100": "आप एक बार में अधिकतम 100 उपयोगकर्ताओं को आयात कर सकते हैं।"
    },
    "importUserButton": {
        "import_user_processing": "आपके उपयोगकर्ताओं को आयात किया जा रहा है"
    },
    "timeForecastingReport": {
        "project_name": "परियोजना का नाम",
        "project_status": "परियोजना की स्थिति",
        "start_date": "प्रारंभ तिथि",
        "due_date": "नियत तिथि",
        "last_logged_date": "अंतिम लॉग की गई तिथि",
        "budget": "बजट",
        "actual": "वास्तविक",
        "forecast": "पूर्वानुमान",
        "estimated_hours": "अनुमानित घंटे",
        "logged_hours": "लॉग किए गए घंटे",
        "remaining_hours": "शेष घंटे",
        "overdue_hours": "देरी से पूरे हुए घंटे",
        "estimated_time_to_complete": "पूरा करने का अनुमानित समय",
        "estimated_complition_date": "अनुमानित पूर्णता तिथि",
        "show_legends": "लीजेंड दिखाएं",
        "show_data_labels": "डेटा लेबल दिखाएं",
        "report_type": "रिपोर्ट प्रकार"
    }
}